<template>

    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">



        <!-- SIDEBAR -->
        <SidebarBody />

        <div class="hp-main-layout" style="overflow-x: hidden;">

            <!-- HEADER -->
            <HeaderBody />

            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content no-pad2">

                <div class="row mb-32 gy-8 dash-top">

                    <div class="col-12">

                        <div class="row g-32">

                            <div class="col-12 col-xl-8">

                                <h2 class="dd-none" style="margin-top: -70px;"></h2>

                                <div class="row gy-0">

                                    <div class="col-12">

                                        <div class="card hp-card-4">

                                            <div class="card-bod">
                                                <div style="width: 100%; height: 250px; ">

                                                    <img :src="profileBack" alt=""
                                                        style="width: 100%; height: 100%; object-fit: cover; "
                                                        class="profB">


                                                    <div v-if="noUserName == 'noUserName'" style="width: 100%; justify-content: flex-end; align-items: center; display: flex; margin-top: 10px; margin-right: 10px; padding-right: 10px;" >

                                                        <button class="btn btn-sm btn-primary"
                                                            style=" color: #fff; border-radius: 15px; padding: 10px 15px; margin-right: 10px;  border-style: none !important;"   @click="subClick2()">
                                                            Subscribe
                                                        </button>

                                                    </div>

                                                    <div v-else style="width: 100%; justify-content: flex-end; align-items: center; display: flex; margin-top: 10px; margin-right: 10px; padding-right: 10px;">


                                                        <button
                                                            class="btn btn-icon-only rounded-circle btn-outline-primary"
                                                            style="margin-right: 10px;" data-bs-toggle="dropdown">
                                                            <i class="hp-text-color-dark-0 ri-2 ri-more-line"
                                                                style="font-size: 24px; font-weight: 900;"></i>
                                                        </button>

                                                        <ul class="dropdown-menu " style="cursor: pointer;">

                                                            <li @click="openMessage" v-if="isFollowing || isFollower || isSubscribed" >
                                                                <div class="dropdown-item dp-hov"
                                                                    style="display: flex; justify-content: center; align-items: center;">
                                                                    <span class="submenu-item-icon">
                                                                        <i class="hp-text-color-dark-0 ri-2 ri-mail-line"
                                                                            style="font-size: 20px;"></i>
                                                                    </span>

                                                                    <span
                                                                        style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Message</span>
                                                                </div>
                                                            </li>

                                                            <li>
                                                                        <div class="dropdown-item dp-hov"
                                                                            style="display: flex; justify-content: center; align-items: center;" data-bs-toggle="modal"
                                                                            data-bs-target="#sendTip">
                                                                            <!-- <span class="submenu-item-icon rounded-circle">
                                                                                <span
                                                                                    style="font-size: 12px; font-weight: 700; border-color: black; border-width: 1px; border-style: solid; border-radius: 50%; padding: 3px 6px;">&#8358;</span>
                                                                            </span> -->

                                                                            <span class="submenu-item-icon">
                                                                                <i class="hp-text-color-dark-0 ri-2 ri-wallet-line" style="font-size: 20px;"></i>
                                                                            </span>

                                                                            <span
                                                                                style="text-align: start; width: 100%; padding-right: 50px; margin-top: 0px; margin-left: 10px;">Send
                                                                                tip</span>
                                                                        </div>
                                                                    </li>

                                                            <li >
                                                                <div class="dropdown-item dp-hov" style="display: flex; justify-content: center; align-items: center;" @click="share"> 
                                                                    <span class="submenu-item-icon">
                                                                        <i class="hp-text-color-dark-0 ri-2 ri-share-line" style="font-size: 20px;"></i>
                                                                    </span>
                                                                    
                                                                    <span style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Share</span>
                                                                </div>
                                                            </li>

                                                            <li>
                                                                <hr class="dropdown-divider">
                                                            </li>

                                                            <li>
                                                                <div class="dropdown-item dp-hov text-danger"
                                                                    style="display: flex; justify-content: center; align-items: center;">
                                                                    <span class="submenu-item-icon">
                                                                        <i class="hp-text-color-dark-0 ri-2 ri-flag-2-line"
                                                                            style="font-size: 20px;"></i>
                                                                    </span>

                                                                    <span
                                                                        style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Report</span>
                                                                </div>
                                                            </li>


                                                        </ul>

                                                        <button 
                                                            class="btn btn-icon-only rounded-circle btn-outline-primary d-none"
                                                            style="margin-right: 10px; " data-bs-toggle="modal"
                                                            data-bs-target="#sendTip">
                                                            <!-- <i class="hp-text-color-dark-0 ri-money-dollar-circle-line" style="font-size: 24px; "></i> -->
                                                            <span>&#8358;</span>
                                                        </button>

                                                        

                                                        <!-- unfollow -->
                                                        <button v-if="isFollowing && userType == 'user'" class="btn btn-sm btn-danger"
                                                            style=" color: #fff; border-radius: 15px; padding: 10px 15px; margin-right: 10px;  border-style: none !important;"
                                                            data-bs-toggle="modal" data-bs-target="#unfollow">

                                                            Unfollow

                                                        </button>

                                                        <button v-if="!isFollowing && userType == 'user'" class="btn btn-sm btn-primary"
                                                            style=" color: #fff; border-radius: 15px; padding: 10px 15px; margin-right: 10px;  border-style: none !important;"
                                                            @click="followUser">

                                                            Follow

                                                        </button>

                                                        <button v-if="isFollowing && userType == 'model'" class="btn btn-icon-only rounded-circle btn-outline-primary"
                                                            style="margin-right: 10px;"
                                                            data-bs-toggle="modal" data-bs-target="#unfollow">

                                                            <i class="hp-text-color-dark-0 ri-2 ri-user-follow-line"
                                                                style="font-size: 18px;"></i>

                                                        </button>

                                                        <button v-if="!isFollowing && userType == 'model'" class="btn btn-icon-only rounded-circle btn-outline-primary"
                                                            style="margin-right: 10px;"
                                                            @click="followUser">

                                                            <i class="hp-text-color-dark-0 ri-2 ri-user-add-line"
                                                                style="font-size: 18px;"></i>

                                                        </button>

                                                        <button v-if="!isSubscribed && userType == 'model'" class="btn btn-sm btn-primary"
                                                            style=" color: #fff; border-radius: 15px; padding: 10px 15px; margin-right: 10px;  border-style: none !important;"   @click="subClick2()">
                                                            Subscribe
                                                        </button>

                                                        <button v-if="isSubscribed && userType == 'model'" class="btn btn-sm btn-outline-primary"
                                                            style=" color: #fff;  border-radius: 15px; padding: 10px 15px; margin-right: 10px;  "  >
                                                            Subscribed
                                                        </button>

                                                    </div>

                                                </div>

                                                <img :src="profilePic" alt=""
                                                    style="border-radius: 50%; width: 90px; height: 90px; object-fit: cover;  border-color: #b2bec3; border-width: 1px; border-style: solid; margin-left: 20px; margin-top: -50px;">

                                                <div style="margin-left: 20px; margin-top: 10px; position: relative;">
                                                    <h5
                                                        style="width: 250px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                                        {{ displayName }}

                                                        <span v-if="userType == 'model'">
                                                            <img src="@/assets/img/check-circle.png" alt="" style="width: 16px; height: 16px; margin-left: 2px; margin-top: -3px;">
                                                        </span>

                                                        <span v-if="sexuality == 'gay'">
                                                            <img src="@/assets/img/gay.png" alt="" style="width: 16px; height: 16px; margin-left: 5px; margin-top: -3px;">
                                                        </span>

                                                        <span v-else-if="sexuality == 'lesbian'">
                                                            <img src="@/assets/img/lesibian.png" alt="" style="width: 16px; height: 16px; margin-left: 5px; margin-top: -3px;">
                                                        </span>

                                                        <span v-else-if="sexuality == 'bisexual'">
                                                            <img src="@/assets/img/bisexual.png" alt="" style="width: 16px; height: 16px; margin-left: 5px; margin-top: -3px;">
                                                        </span>
                                                    
                                                    </h5>

                                                    <p style="margin-top: -15px;">@{{ userName }}</p>


                                                </div>

                                                <!-- <div style="margin-left: 20px; margin-top: 20px;" class="d-flex align-items-center">
                                                    <i class="hp-text-color-dark-0 iconly-Light-Calendar"></i>
                                                
                                                    <span style="margin-left: 10px;">Joined October 2023</span>
                                                </div> -->

                                                <div style="margin-top: 25px; margin-bottom: 0px; margin-left: 20px;"
                                                    class="d-flex" v-if="userType == 'user'">

                                                    <div class="d-flex">
                                                        <strong>{{ kFormatter(followersCount) }}</strong>
                                                        <p style="margin-left: 5px;">Followers</p>
                                                    </div>

                                                    <div class="d-flex" style="margin-left: 20px;">
                                                        <strong>{{ kFormatter(followingCount) }}</strong>
                                                        <p style="margin-left: 5px;">Following</p>
                                                    </div>

                                                    <div class="d-flex" style="margin-left: 20px;">
                                                        <strong>{{ kFormatter(likes) }}</strong>
                                                        <p style="margin-left: 5px;">Likes</p>
                                                    </div>

                                                </div>

                                                <div style="margin-top: 25px; margin-bottom: 0px; margin-left: 20px;"
                                                    class="d-flex" v-else>

                                                    <div class="d-flex">
                                                        <strong>{{ kFormatter(followersCount) }}</strong>
                                                        <p style="margin-left: 5px;">Followers</p>
                                                    </div>

                                                    <div class="d-flex" style="margin-left: 20px;">
                                                        <strong>{{ kFormatter(fanCount) }}</strong>
                                                        <p style="margin-left: 5px;">Fans</p>
                                                    </div>

                                                    <div class="d-flex" style="margin-left: 20px;">
                                                        <strong>{{ kFormatter(likes) }}</strong>
                                                        <p style="margin-left: 5px;">Likes</p>
                                                    </div>

                                                </div>

                                                <div style=" margin-left: 20px;">
                                                    <p class="hp-p1-body">{{ bio }}</p>

                                                </div>

                                                <div style=" margin-left: 20px; margin-bottom: 20px; cursor: pointer; margin-top: 30px;"
                                                    class="d-flex">



                                                    <a :href="twitterLink" target="_blank" v-if="twitter != ''"
                                                        style="margin-right: 10px;">
                                                        <button class="btn btn-sm btn-primary"
                                                            style="border-radius: 25px; padding: 0; background: rgba(100,100,100,0.08) !important; padding-left: 0px; padding-right: 20px; ">
                                                            <img src="@/assets/img/twitter.png" alt=""
                                                                style="width: 30px; object-fit: cover; margin-right: 10px; border-radius: 50%;">
                                                            <span
                                                                class="hp-p1-body hp-text-color-dark-10">Twitter</span>
                                                        </button>
                                                    </a>

                                                    <a :href="instagramLink" target="_blank" v-if="instagram != ''"
                                                        style="margin-right: 10px;">
                                                        <button class="btn btn-sm btn-primary"
                                                            style="border-radius: 25px; padding: 0; background: rgba(100,100,100,0.08) !important; padding-left: 0px; padding-right: 20px; border: none;">
                                                            <img src="@/assets/img/instagram.png" alt=""
                                                                style="width: 30px; object-fit: cover; margin-right: 10px; border-radius: 50%;">
                                                            <span
                                                                class="hp-p1-body hp-text-color-dark-10">Instagram</span>
                                                        </button>
                                                    </a>

                                                    <a :href="facebookLink" target="_blank" v-if="facebook != ''"
                                                        style="margin-right: 10px;">

                                                        <button class="btn btn-sm btn-primary"
                                                            style="border-radius: 25px; padding: 0; background: rgba(100,100,100,0.08) !important; padding-left: 0px; padding-right: 20px; border: none;">
                                                            <img src="@/assets/img/tiktok.png" alt=""
                                                                style="width: 30px; object-fit: cover; margin-right: 10px; border-radius: 50%;">
                                                            <span
                                                                class="hp-p1-body hp-text-color-dark-10">TikTok</span>
                                                        </button>

                                                    </a>

                                                    <a :href="snapLink" target="_blank" v-if="snap != ''"
                                                        style="margin-right: 10px;">

                                                        <button class="btn btn-sm btn-primary"
                                                            style="border-radius: 25px; padding: 0; background: rgba(100,100,100,0.08) !important; padding-left: 0px; padding-right: 20px; border: none;">
                                                            <img src="@/assets/img/snap.png" alt=""
                                                                style="width: 30px; object-fit: cover; margin-right: 10px; border-radius: 50%;">
                                                            <span
                                                                class="hp-p1-body hp-text-color-dark-10">Snapchat</span>
                                                        </button>

                                                    </a>

                                                </div>

                                                <!-- <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0"
                                                    v-if="userType == 'model' && !isSubscribed"></div> -->

                                                <!-- SUB -->
                                                <!-- <div class="accordion accordion-flush dd-none" id="accordionExample"
                                                    style="margin-top: -22px;"
                                                    v-if="userType == 'model' && !isSubscribed">
                                                    <div class="accordion-item">
                                                        <h2 class="accordion-header" id="headingOne"
                                                            style="position: relative; padding: 0; margin: 0;">
                                                            <button class="accordion-button" type="button"
                                                                data-bs-toggle="collapse" data-bs-target="#collapseOne"
                                                                aria-expanded="true" aria-controls="collapseOne">
                                                                <div class="row align-items-center"
                                                                    style="margin-bottom: -30px;">
                                                                    <h5>Subscription Bundles</h5>



                                                                </div>
                                                            </button>

                                                            <button class="btn btn-sm btn-outline-primary"
                                                                data-bs-toggle="collapse" data-bs-target="#collapseOne"
                                                                style="position: absolute;top: 35px; right: 35px; z-index: 9;">Subscribe
                                                            </button>
                                                        </h2>

                                                        <div id="collapseOne" class="accordion-collapse collapse"
                                                            aria-labelledby="headingOne"
                                                            data-bs-parent="#accordionExample">
                                                            <div class="accordion-body">
                                                                <div class="col-12">



                                                                    <div class="d-flex justify-content-between align-items-center"
                                                                        style="padding: 15px 20px 15px 20px; margin: 30px 0px 15px 0px; background-color:  #FFC212; border-radius: 20px; cursor: pointer;"
                                                                        @click="subClick(30, bundle1)">

                                                                        <span class="hp-badge-text"
                                                                            style="color: #fff;">1 month</span>
                                                                        <span class="hp-badge-text"
                                                                            style="color: #fff;">NGN {{ bundle1D
                                                                            }}</span>

                                                                    </div>

                                                                    <div class="d-flex justify-content-between align-items-center"
                                                                        style="padding: 15px 20px 15px 20px; margin: 10px 0px 15px 0px; background-color: #FF7F80; border-radius: 20px; cursor: pointer;"
                                                                        @click="subClick(90, bundle2)">

                                                                        <span class="hp-badge-text"
                                                                            style="color: #fff;">3 months</span>
                                                                        <span class="hp-badge-text"
                                                                            style="color: #fff;">NGN {{ bundle2D
                                                                            }}</span>

                                                                    </div>

                                                                    <div class="d-flex justify-content-between align-items-center"
                                                                        style="padding: 15px 20px 15px 20px; margin: 10px 0px 35px 0px; background-color: #C903FF; border-radius: 20px; cursor: pointer;"
                                                                        @click="subClick(180, bundle3)">

                                                                        <span class="hp-badge-text"
                                                                            style="color: #fff;">6 months</span>
                                                                        <span class="hp-badge-text"
                                                                            style="color: #fff;">NGN {{ bundle3D
                                                                            }}</span>

                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div> -->

                                                <!-- TABS -->
                                                <div style="padding: 20px; margin-top: 5px; ">

                                                    <!-- TABS -->
                                                    <ul class="nav nav-tabs mb-12" id="profileTab" role="tablist">
                                                        <li class="nav-item" role="presentation">
                                                            <h5 class="nav-link active" id="posts-tab"
                                                                data-bs-toggle="tab" data-bs-target="#posts" role="tab"
                                                                aria-controls="posts" aria-selected="true"
                                                                style="cursor: pointer; padding-left: 30px; padding-right: 30px;">
                                                                {{ postCount }} <span style="padding-left: 5px;"></span> Posts </h5>
                                                        </li>

                                                        <li class="nav-item" role="presentation">
                                                            <h5 class="nav-link" id="media-tab" data-bs-toggle="tab"
                                                                data-bs-target="#media" role="tab" aria-controls="media"
                                                                aria-selected="false"
                                                                style="cursor: pointer;padding-left: 30px; padding-right: 30px;">
                                                                {{mediaCount}} <span style="padding-left: 5px;"></span> Media</h5>
                                                        </li>

                                                    </ul>

                                                    <div class="tab-content" id="allTabContent"
                                                        style="padding-bottom: 200px;">

                                                        <!-- POSTS -->
                                                        <div class="tab-pane fade show active" id="posts"
                                                            role="tabpanel" aria-labelledby="posts-tab">

                                                            <div class="col-12" style="margin-bottom: 20px;"
                                                                v-for="(post, index) in postsList"
                                                                :key="'number' + index">

                                                                <div class="card hp-card-4" v-if="post.isLoading">
                                                                    <div class="card-body">
                                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="100" :height="10"/><br>
                                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="100" :height="10"/>
                                                                        <br> <br>

                                                                        <div class="mm-none">
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/><br>
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/><br>
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/>
                                                                        </div>

                                                                        <div class="dd-none">
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/><br>
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/><br>
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/>
                                                                        </div>

                                                                        <br>

                                                                        <div class="mm-none">
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="400"/>
                                                                        </div>

                                                                        <div class="dd-none">
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="300"/>
                                                                        </div>

                                                                        <br>
                                                                        
                                                                    </div>
                                                                </div>

                                                                <div class="card hp-card-4" v-else>
                                                                    <div class="card-body">

                                                                        <div class="row">

                                                                            <div class="col">

                                                                                <i class="hp-text-color-dark-0 ri-2x ri-more-line" style="position: absolute; top: 24px; right: 20px; cursor: pointer;" data-bs-toggle="dropdown" ></i>

                                                                                <ul class="dropdown-menu " style="cursor: pointer;">

                                                                                    <li @click="copy(post.id)" class="toast-btn" data-id="liveToast" id="liveToastBtn">
                                                                                        <div class="dropdown-item " style="display: flex; justify-content: center; align-items: center;" >

                                                                                            <span class="submenu-item-icon">
                                                                                                <i class="hp-text-color-dark-0 ri-2 ri-file-copy-line" style="font-size: 20px;"></i>
                                                                                            </span>

                                                                                            <span style="text-align: start; width: 100%; padding-right: 50px; margin-top: -7px; margin-left: 10px;">Copy link</span>
                                                                                        </div>
                                                                                    </li>

                                                                                    <li >
                                                                                        <div class="dropdown-item " style="display: flex; justify-content: center; align-items: center;" @click="sharePost(post.id)"> 
                                                                                            <span class="submenu-item-icon">
                                                                                                <i class="hp-text-color-dark-0 ri-2 ri-share-line" style="font-size: 20px;"></i>
                                                                                            </span>
                                                                                            
                                                                                            <span style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Share</span>
                                                                                        </div>
                                                                                    </li>

                                                                                    <li>
                                                                                        <hr class="dropdown-divider">
                                                                                    </li>

                                                                                    <li data-bs-toggle="modal" data-bs-target="#reportModal" @click="reportClick(post.id)">
                                                                                        <div class="dropdown-item text-danger"
                                                                                            style="display: flex; justify-content: center; align-items: center;">
                                                                                            <span class="submenu-item-icon">
                                                                                                <i class="hp-text-color-dark-0 ri-2 ri-flag-2-line"
                                                                                                    style="font-size: 20px;"></i>
                                                                                            </span>

                                                                                            <span
                                                                                                style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Report</span>
                                                                                        </div>
                                                                                    </li>


                                                                                </ul>

                                                                                <div class="row align-items-center">
                                                                                    <div class="w-auto px-0">
                                                                                        <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                                            style="width: 48px; height: 48px; ">
                                                                                            <img :src="profilePic"
                                                                                                class="hp-img-cover"
                                                                                                style="width: 48px; height: 48px; background-color: black; object-fit: cover;  border-color: #b2bec3; border-width: 1px; border-style: solid; ">
                                                                                        </div>
                                                                                    </div>

                                                                                    <div class="w-auto ms-8 px-0 mt-12">
                                                                                        <span
                                                                                            class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleM">{{
                                                                                            displayName }}
                                                                                            
                                                                                            <span v-if="userType == 'model'">
                                                                                                <img src="@/assets/img/check-circle.png" alt="" style="width: 12px; height: 12px; margin-left: 2px; margin-top: -3px;">
                                                                                            </span>

                                                                                            <span v-if="post.sexuality == 'gay'">
                                                                                                <img src="@/assets/img/gay.png" alt="" style="width: 12px; height: 12px; margin-left: 5px; margin-top: -3px;">
                                                                                            </span>

                                                                                            <span v-else-if="post.sexuality == 'lesbian'">
                                                                                                <img src="@/assets/img/lesibian.png" alt="" style="width: 12px; height: 12px; margin-left: 5px; margin-top: -3px;">
                                                                                            </span>

                                                                                            <span v-else-if="post.sexuality == 'bisexual'">
                                                                                                <img src="@/assets/img/bisexual.png" alt="" style="width: 12px; height: 12px; margin-left: 5px; margin-top: -3px;">
                                                                                            </span>

                                                                                        </span>
                                                                                        <p
                                                                                            class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">
                                                                                            @{{ userName }}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <p v-if="post.previewUrl == ''"
                                                                                style="margin-top: 30px; margin-bottom: -5px;">
                                                                                {{ post.caption }}</p>
                                                                            <p v-else
                                                                                style="margin-top: 10px; margin-bottom: -5px;">
                                                                                {{ post.caption }}</p>



                                                                        </div>

                                                                    </div>

                                                                    <div style="width: 100%; height: 100%; ">

                                                    <!-- <div v-if="post.mediaList.length > 0" style="width: 100%; height: 100%; position: absolute; top: 0; border-radius: 0px;" class="card-overlay"></div> -->

                                                    <div v-if="post.postType == 'paid' && post.isPaid && post.isSubscribed"
                                                        style="cursor: pointer; ">

                                                        <div v-if="post.mediaList.length > 0"
                                                            style=" color: #fff; width: 100%; height: 100%; background-color: transparent;"
                                                            @click="post.toggler = !post.toggler">

                                                            <!-- 1  -->
                                                            <div v-if="post.mediaList.length == 1"
                                                                style="width: 100%; height: 400px; background-color: #9146ff;">

                                                                <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                    :src="post.mediaList[0].url" alt="Baesnap"
                                                                    style=" width: 100%; height: 400px; object-fit: cover; ">

                                                                <div v-else >

                                                                    <video 
                                                                    style="height: 400px; width: 100%; object-fit: cover; pointer-events: none; background-color: #b2bec3; ">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/mp4">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/ogg">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/webm">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/3gp">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/quicktime">
                                                                        Your browser does not support the video tag.

                                                                    </video>

                                                                    <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%;">
                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                    </div>

                                                                </div>
                                                                
                                                            </div>

                                                            <!-- 2 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 2"
                                                                style=" width: 100%;  height: 400px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else >

                                                                        <video
                                                                        style="height: 400px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; right: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                    

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                        :src="post.mediaList[1].url" alt="baesnap"
                                                                        style=" height: 400px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video  
                                                                        style="height: 400px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; left: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                            </div>

                                                            <!-- 3 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 3"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video 
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; top: 50%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="width: 100%; height: 275px; padding-bottom: 5px;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 100%; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 100%; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  top: 33%; ">
                                                                                    <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="width: 100%; height: 275px">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  bottom: 23%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- 4 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px; ">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- more -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length > 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <video v-else controls
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div style="width: 100%; height: 100%; position: absolute; top: 0%;  border-radius: 0px; color: #fff;"
                                                                            class="card-overlay d-flex justify-content-center align-items-center">

                                                                            <h1 style="color: #fff;"> + {{
                                                                                post.mediaList.length - 4 }}</h1>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div v-else>

                                                            <img v-if="post.previewUrl != ''" :src="post.previewUrl"
                                                                alt=""
                                                                style=" width: 100%; height: 400px; object-fit: cover; "
                                                                @click="post.toggler = !post.toggler">

                                                        </div>

                                                        <FsLightbox
                                                            :toggler="post.toggler" :sources="post.urlList" ></FsLightbox>

                                                        

                                                    </div>

                                                    <div v-else-if="post.postType == 'paid' && !post.isPaid && post.isSubscribed"  style="position: relative; width: 100%"
                                                        class="d-flex justify-content-center align-items-center">

                                                        <img v-if="post.previewUrl != ''" :src="post.previewUrl" alt=""
                                                            style=" width: 100%; height: 400px; object-fit: cover; cursor: pointer;"
                                                            @click="post.toggler = !post.toggler">

                                                        <div v-if="post.previewUrl != '' && post.mediaList.length > 0"
                                                            style=" width: 95%; color: #fff; border-radius: 5px; border-width: 1px; border-style: dashed; border-color: #9146ff; padding: 20px 10px 20px 10px;  position: absolute; bottom: 10px; flex-direction: column;"
                                                            class=" d-flex justify-content-center align-items-center card-overlay">

                                                            <div
                                                                class=" d-flex justify-content-center align-items-center ">

                                                                <button v-if="post.imgCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Image"></i>
                                                                    <span style="padding-left: 5px;">{{ post.imgCount }}
                                                                        Images</span>
                                                                </button>

                                                                <button v-if="post.vidCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Video"></i>
                                                                    <span style="padding-left: 5px;">{{ post.vidCount }}
                                                                        Videos</span>
                                                                </button>

                                                            </div>

                                                            <button @click="ppvClick(post)" class="btn btn-primary"
                                                                
                                                                style="width: 90%; margin-bottom: 20px;">
                                                                <i class="iconly-Light-Lock"></i>
                                                                <span style="padding-left: 5px;">Unlock post for &#8358; {{ post.priceD }}</span>
                                                            </button>
                                                        </div>

                                                        <FsLightbox :toggler="post.toggler" :sources='post.previewUrl2' />

                                                        

                                                    </div>

                                                    <div v-else-if="post.isSubscribed || post.isOwner || post.postType == 'freex' "
                                                        style="cursor: pointer; ">

                                                        <div v-if="post.mediaList.length > 0"
                                                            style=" color: #fff; width: 100%; height: 100%; background-color: transparent;"
                                                            @click="post.toggler = !post.toggler">

                                                            <!-- 1  -->
                                                            <div v-if="post.mediaList.length == 1"
                                                                style="width: 100%; height: 400px; background-color: #9146ff;">

                                                                <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                    :src="post.mediaList[0].url" alt="Baesnap"
                                                                    style=" width: 100%; height: 400px; object-fit: cover; ">

                                                                <div v-else >

                                                                    <video 
                                                                    style="height: 400px; width: 100%; object-fit: cover; pointer-events: none; background-color: #b2bec3; ">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/mp4">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/ogg">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/webm">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/3gp">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/quicktime">
                                                                        Your browser does not support the video tag.

                                                                    </video>

                                                                    <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%;">
                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                    </div>

                                                                </div>
                                                                
                                                            </div>

                                                            <!-- 2 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 2"
                                                                style=" width: 100%;  height: 400px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 400px; width: 100%; object-fit: cover; ">

                                                                    <div v-else >

                                                                        <video
                                                                        style="height: 400px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; right: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                    

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                        :src="post.mediaList[1].url" alt="Baesnap"
                                                                        style=" height: 400px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video  
                                                                        style="height: 400px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; left: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                            </div>

                                                            <!-- 3 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 3"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video 
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; top: 50%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="width: 100%; height: 275px; padding-bottom: 5px;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 100%; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 100%; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  top: 33%; ">
                                                                                    <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="width: 100%; height: 275px">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  bottom: 23%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- 4 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px; ">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- more -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length > 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <video v-else controls
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div style="width: 100%; height: 100%; position: absolute; top: 0%;  border-radius: 0px; color: #fff;"
                                                                            class="card-overlay d-flex justify-content-center align-items-center">

                                                                            <h1 style="color: #fff;"> + {{
                                                                                post.mediaList.length - 4 }}</h1>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div v-else>

                                                            <img v-if="post.previewUrl != ''" :src="post.previewUrl"
                                                                alt=""
                                                                style=" width: 100%; height: 400px; object-fit: cover; "
                                                                @click="post.toggler = !post.toggler">

                                                        </div>

                                                        <FsLightbox
                                                            :toggler="post.toggler" :sources="post.urlList" ></FsLightbox>

                                                        

                                                    </div>

                                                    <div v-else style="position: relative; width: 100%"
                                                        class="d-flex justify-content-center align-items-center">

                                                        <img v-if="post.previewUrl != ''" :src="post.previewUrl" alt=""
                                                            style=" width: 100%; height: 400px; object-fit: cover; cursor: pointer;"
                                                            @click="post.toggler = !post.toggler">

                                                        <div v-if="post.previewUrl != '' && post.mediaList.length > 0"
                                                            style=" width: 95%; color: #fff; border-radius: 5px; border-width: 1px; border-style: dashed; border-color: #9146ff; padding: 20px 10px 20px 10px;  position: absolute; bottom: 10px; flex-direction: column;"
                                                            class=" d-flex justify-content-center align-items-center card-overlay">

                                                            <div
                                                                class=" d-flex justify-content-center align-items-center ">

                                                                <button v-if="post.imgCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Image"></i>
                                                                    <span style="padding-left: 5px;">{{ post.imgCount }}
                                                                        Images</span>
                                                                </button>

                                                                <button v-if="post.vidCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Video"></i>
                                                                    <span style="padding-left: 5px;">{{ post.vidCount }}
                                                                        Videos</span>
                                                                </button>

                                                            </div>

                                                            <button v-if="noUserName == 'noUserName'" @click="subClick3()" class="btn btn-primary"
                                                                
                                                                style="width: 90%; margin-bottom: 20px;">
                                                                <i class="iconly-Light-Lock"></i>
                                                                <span style="padding-left: 5px;">Subscribe to unlock
                                                                    post</span>
                                                            </button>

                                                            <button v-else @click="subClick2()" class="btn btn-primary"
                                                                
                                                                style="width: 90%; margin-bottom: 20px;">
                                                                <i class="iconly-Light-Lock"></i>
                                                                <span style="padding-left: 5px;">Subscribe to unlock
                                                                    post</span>
                                                            </button>
                                                        </div>

                                                        <FsLightbox :toggler="post.toggler" :sources='post.previewUrl2' />

                                                        

                                                    </div>

                                                                    </div>

                                                                    <div
                                                                        style="width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 20px;">

                                                                        <div v-if="noUserName == 'noUserName'"></div>
                                                                        <div v-else style="display: flex; justify-content: center; align-items: center;">

                                                                            <div>

                                                                                <div v-if="post.isLiked"
                                                                                    :id="post.idD + 'like'"
                                                                                    @click="likeClick(post.idD + 'like', index, post)"
                                                                                    class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-danger bg-danger-4 hp-bg-color-dark-danger">
                                                                                    <i class=" iconly-Light-Heart2"></i>
                                                                                </div>

                                                                                <div v-else :id="post.idD + 'like'"
                                                                                    @click="likeClick(post.idD + 'like', index, post)"
                                                                                    class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                                                    <i class=" iconly-Light-Heart2"></i>
                                                                                </div>

                                                                            </div>

                                                                            <span
                                                                                style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                                                class="hp-badge-text">
                                                                                {{ post.likeCount }}
                                                                            </span>

                                                                            <div v-if="post.isBookmarked"
                                                                                :id="post.idD + 'book'"
                                                                                @click="bookClick(post.idD + 'book', index, post)"
                                                                                class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-primary bg-primary-4 hp-bg-color-dark-primary">
                                                                                <i
                                                                                    class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                                            </div>

                                                                            <div v-else :id="post.idD + 'book'"
                                                                                @click="bookClick(post.idD + 'book', index, post)"
                                                                                class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                                                <i
                                                                                    class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                                            </div>

                                                                            <span
                                                                                style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                                                class="hp-badge-text">
                                                                                {{ post.bookmarkCount }}
                                                                            </span>

                                                                            <div v-if="post.commentCount > 0"
                                                                                @click="commentClick(post, index)"
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#comments"
                                                                                class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-dark bg-dark-4 bg-black-10 hp-bg-color-dark-90">
                                                                                <i
                                                                                    class="hp-text-color-dark-0 iconly-Light-Chat hp-cursor-pointer "></i>
                                                                            </div>

                                                                            <div v-else
                                                                                @click="commentClick(post, index)"
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#comments"
                                                                                class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                                                <i
                                                                                    class="hp-text-color-dark-0 iconly-Light-Chat hp-cursor-pointer "></i>
                                                                            </div>



                                                                            <span
                                                                                style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                                                class="hp-badge-text">
                                                                                {{ post.commentCount }}
                                                                            </span>

                                                                        </div>

                                                                        <!-- <div>

                                                                            <div class="d-flex align-items-center justify-content-center hp-cursor-pointer " data-bs-toggle="modal" data-bs-target="#sendTip">
                                                                                <i class="hp-text-color-dark-0 ri-2x ri-money-dollar-circle-line"></i>
                                                                                
                                                                            </div>

                                                                        </div> -->

                                                                    </div>

                                                                    <!-- end -->
                                                                </div>

                                                            </div>

                                                            <div style="width:100%; display: flex; justify-content: center; align-items: center;"
                                                                id="emptyPost2">

                                                                <InfiniteLoading @infinite="handleInfinite"
                                                                    class="spinner">

                                                                </InfiniteLoading>

                                                            </div>

                                                            <div style="margin-top: 200px; margin-bottom: 400px; display: flex; justify-content: center; align-items: center; flex-direction: column;"
                                                                id="emptyPost">
                                                                <p class="hp-badge-text">No posts yet...</p>
                                                            </div>


                                                        </div>

                                                        <!-- MEDIA -->
                                                        <div class="tab-pane fade" id="media" role="tabpanel"
                                                            aria-labelledby="media-tab">

                                                            <div class="row g-8">

                                                                <div class="col-6 col-xl-3" style="margin-bottom: 10px;" v-for="(post, index) in postsMediaList" :key="'number'+index">
                                                                
                                                                <div class="card hp-card-" style="height: 150px !important; border-radius: 10px;">
                                                                    <div class="card-bod" >

                                                                        <div style="width: 100%; height: 100%;">

                                                                            <!-- <div v-if="post.mediaList.length > 0" style="width: 100%; height: 100%; position: absolute; top: 0; border-radius: 0px;" class="card-overlay"></div> -->

                                                                            <div style="cursor: pointer; " v-if="post.postType == 'paid' && post.isPaid && isSubscribed">

                                                                                <img :src="post.url" alt="" v-if="post.type == 'image'" style="object-fit: cover; width: 100%; height: 150px; border-radius: 10px;" @click="post.toggler = !post.toggler">

                                                                                <div v-else >

                                                                                    <video 
                                                                                    style="height: 150px; width: 100%; object-fit: cover; pointer-events: none; border-radius: 10px; background-color: #b2bec3; " >
                                                                                        <source :src="post.url"
                                                                                            type="video/mp4">
                                                                                        <source :src="post.url"
                                                                                            type="video/ogg">
                                                                                        <source :src="post.url"
                                                                                            type="video/webm">
                                                                                        <source :src="post.url"
                                                                                            type="video/3gp">
                                                                                        <source :src="post.url"
                                                                                            type="video/quicktime">
                                                                                        Your browser does not support the video tag.

                                                                                    </video>

                                                                                    <div @click="post.toggler = !post.toggler" class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 35%;">
                                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 50px; height: 50px;">
                                                                                    </div>

                                                                                </div>

                                                                                

                                                                            </div>

                                                                            <div v-else-if="post.postType == 'paid' && !post.isPaid && isSubscribed">

                                                                                <div style="object-fit: cover; width: 100%; height: 150px; border-radius: 10px; background-color: #000;" class="d-flex justify-content-center align-items-center">

                                                                                    <button @click="ppvClick(post)" class="btn btn-icon-only rounded-circle btn-danger">
                                                                                        <i class="hp-text-color-dark-0 iconly-Light-Lock"></i>
                                                                                    </button>

                                                                                </div>

                                                                            </div>

                                                                            <div style="cursor: pointer; " v-else-if="isSubscribed || profileType == 'free' || post.postType == 'freex' ">

                                                                                <img :src="post.url" alt="" v-if="post.type == 'image'" style="object-fit: cover; width: 100%; height: 150px; border-radius: 10px;" @click="post.toggler = !post.toggler">

                                                                                <div v-else >

                                                                                    <video 
                                                                                    style="height: 150px; width: 100%; object-fit: cover; pointer-events: none; border-radius: 10px; background-color: #b2bec3; " >
                                                                                        <source :src="post.url"
                                                                                            type="video/mp4">
                                                                                        <source :src="post.url"
                                                                                            type="video/ogg">
                                                                                        <source :src="post.url"
                                                                                            type="video/webm">
                                                                                        <source :src="post.url"
                                                                                            type="video/3gp">
                                                                                        <source :src="post.url"
                                                                                            type="video/quicktime">
                                                                                        Your browser does not support the video tag.

                                                                                    </video>

                                                                                    <div @click="post.toggler = !post.toggler" class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 35%;">
                                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 50px; height: 50px;">
                                                                                    </div>

                                                                                </div>

                                                                                

                                                                            </div>

                                                                            <div v-else>

                                                                                <div style="object-fit: cover; width: 100%; height: 150px; border-radius: 10px; background-color: #000;" class="d-flex justify-content-center align-items-center">

                                                                                    <button @click="subClick2()" class="btn btn-icon-only rounded-circle btn-danger">
                                                                                        <i class="hp-text-color-dark-0 iconly-Light-Lock"></i>
                                                                                    </button>

                                                                                </div>

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                                <FsLightbox :toggler="post.toggler" :sources="post.urlList" ></FsLightbox>
                                                                <!--end-->
                                                                </div>

                                                                <div style="width:100%; display: flex; justify-content: center; align-items: center;"
                                                                    id="emptyMedia2">

                                                                    <InfiniteLoading @infinite="handleInfinite2"
                                                                        class="spinner">

                                                                    </InfiniteLoading>

                                                                </div>

                                                                <div style="margin-top: 200px; margin-bottom: 400px; display: flex; justify-content: center; align-items: center; flex-direction: column;"
                                                                    id="emptyMedia">
                                                                    <p class="hp-badge-text">No media yet...</p>
                                                                </div>

                                                            </div>

                                                        </div>



                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <!-- SUGGESTIONS -->
                            <div class="col-12 col-xl-4">

                                <div class="row g-32 mm-none" style="margin-bottom: 20px; position: fixed; width: 380px;"
                                    v-if="userType == 'model'">

                                    <div class="card hp-card-4">

                                        <div class="card-body">
                                            <div class="row">
                                                <h4 style="margin-top: 10px; text-align: center;">Subscription
                                                </h4>
                                                <p class="hp-p1-body"> {{ subDescription }}</p>

                                                <div
                                                    class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0">
                                                </div>

                                                <div class="col-12">

                                                    <div v-if="noUserName == 'noUserName'" class="d-flex justify-content-center align-items-center  mt-18 mb-18">

                                                        

                                                        <router-link :to="{name: 'sign-in'}">
                                                            <button class="btn btn-primary w-100">
                                                                Starting at &#8358; {{ bundle1D }}/month
                                                            </button>
                                                        </router-link>

                                                        

                                                    </div>

                                                    <div v-else class="d-flex justify-content-center align-items-center  mt-18 mb-18">

                                                        <button v-if="isSubscribed" type="button" class="btn btn-outline-primary w-100" >
                                                            <span style="text-align: start; width: 100%;">Subscribed</span>
                                                            <span style="text-align: end; width: 100%;">&#8358; {{ xxPriceD }}</span>
                                                        </button>

                                                        <button v-else class="btn btn-primary w-100" @click="subClick2()">
                                                            Starting at &#8358; {{ bundle1D }}/month
                                                        </button>

                                                        

                                                    </div>

                                                </div>




                                            </div>
                                        </div>

                                    </div>

                                </div>

                                <div v-else>
                                    <SuggestionsBody />
                                </div>

                                <div style="padding-top: 5px;"></div>

                                

                            </div>

                        </div>

                    </div>


                </div>

                <!-- FOOTER -->
                <FooterBody />

            </div>

        </div>

    </main>

    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px"
                width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z">
                    </path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal2">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText2 }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS2">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ERROR -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg "
        ref="errorModal">

        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 30px;">

                            <h5 class="mt-24 mb-16 me-4 text-danger">Error!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ errorText }} </p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;"
                                @click="closeE">Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- LOADING -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="loadingModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">

                        <div class="col-12 text-center">
                            <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;">
                        </div>

                        <div class="col-12 text-center">
                            <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ loadingText }} </p>

                            <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- UNLOCK1 -->
    <div class="modal fade" id="unlock1" tabindex="-1" aria-labelledby="unlock1Label" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">Subscribe to view</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>



                <div class="modal-body" style="margin-top: -30px;">

                    <p class="hp-p1-body">Subscribe to gain full and unlimited access to all content from this model.
                        You can cancel your subscription at any time. </p>

                    <div @click="subClick(30, bundle1)" class="d-flex justify-content-between align-items-center"
                        style="padding: 15px 20px 15px 20px; margin: 30px 10px 15px 10px; background-color: #FF7F80; border-radius: 20px; cursor: pointer;">

                        <span class="hp-badge-text" style="color: #fff;">1 month</span>
                        <span class="hp-badge-text" style="color: #fff;">₦ {{ bundle1D }}</span>

                    </div>

                    <div @click="subClick(90, bundle2)" class="d-flex justify-content-between align-items-center"
                        style="padding: 15px 20px 15px 20px; margin: 10px 10px 15px 10px; background-color: #FFC212; border-radius: 20px; cursor: pointer;">

                        <span class="hp-badge-text" style="color: #fff;">3 months</span>
                        <span class="hp-badge-text" style="color: #fff;">₦ {{ bundle2D }}</span>

                    </div>

                    <div @click="subClick(180, bundle3)" class="d-flex justify-content-between align-items-center"
                        style="padding: 15px 20px 15px 20px; margin: 10px 10px 15px 10px; background-color: #C903FF; border-radius: 20px; cursor: pointer;">

                        <span class="hp-badge-text" style="color: #fff;">6 months</span>
                        <span class="hp-badge-text" style="color: #fff;">₦ {{ bundle3D }}</span>

                    </div>

                </div>

                <!-- <div class="modal-footer">
                        <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-danger">Close</button>
                    </div> -->
            </div>
        </div>
    </div>

    <!-- UnLOCK2 -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 99999;" class="loadingModalBg"
        ref="subModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">

                <div
                    style="display: flex; justify-content: center; align-items: center; width: 100%; margin-top: -40px; flex-direction: column;">
                    <img :src="profilePic"
                        style="width: 100px; height: 100px; border-radius: 50%; border-color: #000; border-width: 1px; border-style: solid; background-color: #fff; margin-bottom: 10px; object-fit: cover;">

                </div>



                <div class="card-bod" style="margin-top: -10px;">
                    <div class="row">

                        <div class="col-12 text-center">

                            <h5 class="mt-24 mb-16 me-4 ">Subscription Benefits</h5>

                            <div
                                style="display: flex; justify-content: flex-start; align-items: center; width: 100%; padding-left: 10px; padding-right: 10px; margin-top: 25px;">

                                <img src="@/assets/img/check-circle.png" alt=""
                                    style="width: 20px; margin-right: 10px;">
                                <span class="hp-p1-body">Full access to this user's content</span>

                            </div>

                            <div
                                style="display: flex; justify-content: flex-start; align-items: center; width: 100%; padding-left: 10px; padding-right: 10px; margin-top: 20px;">

                                <img src="@/assets/img/check-circle.png" alt=""
                                    style="width: 20px; margin-right: 10px;">
                                <span class="hp-p1-body">Direct message with this user</span>

                            </div>

                            <div
                                style="display: flex; justify-content: flex-start; align-items: center; width: 100%; padding-left: 10px; padding-right: 10px; margin-top: 20px;">

                                <img src="@/assets/img/check-circle.png" alt=""
                                    style="width: 20px; margin-right: 10px;">
                                <span class="hp-p1-body">Cancel your subscription at any time</span>

                            </div>


                        </div>

                        <div class="divider mt-18 mb-16"></div>

                        <div class="col-12 text-center" style="margin-top: 10px; margin-bottom: 10px;">
                            <button @click="subscribe" class="btn btn-primary">Subscribe for ₦ {{ priceD }}</button>


                        </div>

                        <div class="col-12 text-center">
                            <button class="btn btn-sm btn-danger" @click="closeSub">Close</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- SEND TIP -->
    <div class="modal fade" id="sendTip" tabindex="-1" aria-labelledby="sendTipLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">

                    <div class="w-auto px-0" >
                        <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 48px; height: 48px; ">
                            <img :src="profilePic" class="hp-img-cover" style=" width: 48px; height: 48px;  background-color: black; object-fit: cover; border-color: #000; border-width: 1px; border-style: solid; pointer-events: all !important;">
                        </div>
                    </div>

                    <h4 style="text-align: center; width: 100%" class="modal-title">Send Tip</h4>

                    <button style="z-index: 10;" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        ></button>
                    
                </div>



                <div class="modal-body" style="margin-top: -40px;">

                    <!-- <p class="hp-p1-body">Send a token of appreciation to [model name]</p> -->

                    <form @submit.prevent="sendTip">

                        <div class="mb-24" style="margin-top: 30px;">

                            <label for="displayName" class="form-label">Amount</label>
                            <div class="input-group mb-16">
                                <span class="input-group-text" id="basic-addon1">&#8358;</span>
                                <input type="number" class="form-control" placeholder="100 to 50,000"
                                    aria-label="Username" aria-describedby="basic-addon1" required v-model="tip">
                            </div>

                        </div>

                        <div class="mb-24">

                            <label for="displayName" class="form-label">Message</label>
                            <textarea name="description" id="description" class="form-control" rows="4"
                                placeholder="Type a message here..." style="line-height: 20px; padding-top: 10px;"
                                v-model="message" maxlength="200"></textarea>

                        </div>

                        <div class="divider mt-18 mb-16"></div>



                        <div class="modal-footer d-flex justify-content-center">

                            <button class="btn btn-primary">Confirm</button>
                        </div>

                    </form>







                </div>


            </div>
        </div>
    </div>

    <!-- MEDIA GALLERY -->
    <div class="modal fade" id="mediaGallery" tabindex="-1" aria-labelledby="mediaGalleryLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-fullscreen">
            <div class="modal-content">
                <div class="modal-header">

                    <h5 class="modal-title">Media gallery ( @{{ modelUsername }} )</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body" style="margin-top: -30px;">

                    <div v-if="mediaUrl != ''"
                        style="display: flex; justify-content: center; align-items: center; margin-bottom:10px ;">

                        <video controls controlsList="nodownload" oncontextmenu="return false;"
                            v-if="mediaType.startsWith('video')" class="shm">
                            <source :src="mediaUrl" type="video/mp4">
                            <source :src="mediaUrl" type="video/ogg">
                            <source :src="mediaUrl" type="video/webm">
                            <source :src="mediaUrl" type="video/3gp">
                            <source :src="mediaUrl" type="video/quicktime">
                            Your browser does not support the video tag.

                        </video>

                        <img :src="mediaUrl" alt="" v-else class="shm" style="object-fit: cover;">



                    </div>

                    <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0"></div>

                    <div class="d-flex align-items-center justify-content-center" style="flex-wrap: wrap;">

                        <!-- dupli img-->
                        <div v-for="(media, index) in mediaList" :key="index"
                            style="position: relative; border-radius: 5px; border-width: 1px; border-color: #b2bec3; margin-right: 10px; padding: 5px; margin-bottom: -5px;">

                            <div v-if="media.type.startsWith('image')" @click="playMedia(media)">
                                <img :src="media.url" alt=""
                                    style="width: 90px; height: 90px; object-fit: cover; border-radius: 5px; cursor: pointer;">

                                <p class="hp-input-description" style="text-align: center; margin-top: 5px;">{{
                                    fileSizeFormat(media.size) }} </p>
                            </div>

                            <div v-else
                                style="position: relative; border-radius: 5px; border-width: 1px; border-color: #b2bec3; margin-right: 10px; padding: 5px; margin-bottom: -5px;">

                                <div @click="playMedia(media)">
                                    <video
                                        style="width: 90px; height: 90px; border-radius: 5px; object-fit: cover; position: relative;"
                                        oncontextmenu="return false;">
                                        <source :src="media.url" type="video/mp4">
                                        <source :src="media.url" type="video/ogg">
                                        <source :src="media.url" type="video/webm">
                                        <source :src="media.url" type="video/3gp">
                                        <source :src="media.url" type="video/quicktime">
                                        Your browser does not support the video tag.

                                    </video>

                                    <i class="hp-text-color-dark-0 position-absolute ri-2x ri-play-circle-fill"
                                        style="color: #fff; top: 25%; left: 35%; cursor: pointer;"></i>

                                    <p class="hp-input-description" style="text-align: center; margin-top: 5px;">{{
                                        fileSizeFormat(media.size) }} </p>
                                </div>

                            </div>

                        </div>

                    </div>

                    <!-- <div class="modal-footer d-flex justify-content-center">
                            <button type="button" class="btn btn-primary" style="color: #fff;">Download all</button>
                        </div> -->


                </div>

            </div>
        </div>
    </div>

    <!-- SHOW -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 9999;" class="loadingModalBg"
        ref="showModal">
        <div class="col-12 col-xl-12 shx">
            <div class="card hp-card-6">
                <div class="card-body" style="position: relative;">

                    <button type="button" class="btn-close hp-bg-none d-flex align-items-center justify-content-center"
                        style="position:absolute; top:10px; right: 10px;" @click="closeShow">
                        <i class="ri-close-line hp-text-color-dark-0 lh-1" style="font-size: 24px;"></i>
                    </button>

                    <div class="row">

                        <h4 style="text-align: center;">{{ mediaName }}</h4>

                        <div style="display: flex; justify-content: center; align-items: center;">

                            <video controls v-if="mediaType.startsWith('video')" class="shm">
                                <source :src="mediaUrl" type="video/mp4">
                                <source :src="mediaUrl" type="video/ogg">
                                <source :src="mediaUrl" type="video/webm">
                                <source :src="mediaUrl" type="video/3gp">
                                <source :src="mediaUrl" type="video/quicktime">
                                Your browser does not support the video tag.

                            </video>

                            <img :src="mediaUrl" alt="" class="shm" v-else>



                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- COMMENTS -->
    <div class="modal fade" id="comments" tabindex="-1" aria-labelledby="commentsLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h4 class="modal-title">{{ commentCount }} Comments</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="z-index: 5;"></button>
                    </div>

                    <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0" ></div>

                    <div class="modal-body" style="margin-top: -25px;">

                        <div id="comDiv"></div>

                        <div class="col-12" v-for="(com, index) in comments" :key="index">

                            <div class="row">
                                <div class="col-12" style="margin-bottom: 20px;" >
                                    <div style="justify-content: flex-start; display: flex; align-items: flex-start; width: 100%;">
                                        <div class="w-auto px-0" @click="profileClick(com.userId, com.userName)" style="cursor: pointer;" data-bs-dismiss="modal">
                                            <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 38px; height: 38px; ">
                                                <img :src="com.profilePic"  class="hp-img-cover" style="width: 38px; height: 38px; background-color: black; object-fit: cover; ">
                                            </div>
                                        </div>

                                        <div class="w-auto ms-8 px-0 mt-4" style="width: 100%;">
                                            <p class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 mt-4 titleM" style="font-size: 14px;"> {{ com.name }}  </p>
                                            <p style="font-size: 12px; margin-top: -5px; width: 100%; word-break: break-all;" class=" fw-normal hp-text-color-dark-30"> {{ com.comment }} </p>

                                            <p style="font-size: 9px; font-style: italic;" class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">{{ com.date }}</p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div v-if="commentCount == 0" style="margin-top: 50px; margin-bottom: 50px; display: flex; justify-content: center; align-items: center; flex-direction: column;" >
                            <p class="hp-badge-text">No comments yet...</p>
                        </div>

                        <div v-if="commentCount > 20" style="margin-top: 0px; margin-bottom: 50px; display: flex; justify-content: center; align-items: center; flex-direction: column;" >
                            <button data-bs-dismiss="modal" class="btn btn-sm btn-primary" @click="postClick(postId)">Load more</button>
                        </div>

                    
                    </div>

                    <form @submit.prevent="postComment" style="width: 100%; padding: 20px;">

                        <div
                            style="display: flex; justify-content: center; align-items: center; width: 100%; margin-top: 0px;">

                            <div style="width: 100%; margin-right: 10px;">

                                <textarea style="line-height: 20px; padding-top: 10px;" name="description"
                                    v-model="commentInput" maxlength="300" class="form-control" rows="3"
                                    placeholder="Type comment here..." required></textarea>
                            </div>

                            <button class="btn btn-sm btn-icon-only rounded-circle btn-primary" id="commentBtn">
                                <i class="hp-text-color-dark-0 iconly-Light-Send"></i>
                            </button>

                            <!-- <button class="btn btn-sm btn-primary" style="color: #fff;" >Send</button> -->

                        </div>

                    </form>

                    
                </div>
            </div>
    </div>

    <!-- UNFOLLOW -->
    <div class="modal fade" id="unfollow" tabindex="-1" aria-labelledby="unfollowLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">Unfollow @{{ userName }}?</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>



                <div class="modal-body" style="margin-top: -30px;">

                    <p class="hp-p1-body"> Their posts might no longer appear on your timeline and you might not be able
                        to send messages to them. You can still view their profile </p>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-text" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                        @click="unfollowUser">Unfollow</button>
                </div>
            </div>
        </div>
    </div>

    <!-- PPV -->
        <div class="modal fade" id="ppv" tabindex="-1" aria-labelledby="ppvLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h4 class="modal-title">Pay &#8358; {{ppvPost.priceD}} </h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    

                    <div class="modal-body" style="margin-top: -30px;">

                        <!-- <p class="hp-p1-body">Pay <strong></strong> to gain full access to this post </p> -->
                        
                        <div class="mb-24" style="margin-top: 10px;">

                            <label for="displayName" class="form-label">Password</label>
                            <input type="password" class="form-control" placeholder="*********" aria-label="Username"
                                    aria-describedby="basic-addon1" required v-model="password">

                        </div>

                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" @click="ppv">Pay</button>
                    </div>
                </div>
            </div>
        </div>

    <!-- COPY TOAST -->
        <div class="position-fixed bottom-0 end-0 p-16" style="z-index: 99">
            <div data-id="liveToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true" id="toastDiv" style="background-color: #e8def7; padding: 10px;">
                <div class="toast-header" style="background-color: #e8def7;">
                    
                    <strong class="me-auto">Baesnap</strong>
                    <small>1 second ago</small>
                    <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>

                <div class="toast-body">
                    {{toastMessage}}
                </div>
            </div>
        </div>

        <!-- REPORT -->
        <div class="modal fade" id="reportModal" tabindex="-1" aria-labelledby="reportModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="centeredBackdropLabel">Report</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body">
                        <form @submit.prevent="report">

                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="reportReason" id="reportReason1" checked v-model="reportReason" value="Violates Baesnap Terms of Service">
                                <label class="form-check-label" for="reportReason1">
                                    Violates Baesnap Terms of Service
                                </label>
                            </div>

                            <div class="form-check" style="margin-top: 10px;">
                                <input class="form-check-input" type="radio" name="reportReason" id="reportReason2" v-model="reportReason" value="Contains copyrighted material (DMCA)">
                                <label class="form-check-label" for="reportReason2">
                                    Contains copyrighted material (DMCA)
                                </label>
                            </div>

                            <div class="form-check" style="margin-top: 10px;">
                                <input class="form-check-input" type="radio" name="reportReason" id="reportReason3" v-model="reportReason" value="Child Sexual Abuse Material (CSAM)">
                                <label class="form-check-label" for="reportReason3">
                                    Child Sexual Abuse Material (CSAM)
                                </label>
                            </div>

                            <div class="form-check" style="margin-top: 10px;">
                                <input class="form-check-input" type="radio" name="reportReason" id="reportReason4" v-model="reportReason" value="Report Spam">
                                <label class="form-check-label" for="reportReason4">
                                    Report Spam
                                </label>
                            </div>

                            <div class="form-check" style="margin-top: 10px;">
                                <input class="form-check-input" type="radio" name="reportReason" id="reportReason5" v-model="reportReason" value="Report Abuse">
                                <label class="form-check-label" for="reportReason5">
                                    Report Abuse
                                </label>
                            </div>

                            <div class="mb-24" style="margin-top: 30px;">
                                <label for="orderDetails" class="form-label"> Message <span class="text-danger me-4">*</span> </label>
                                <textarea name="orderDetails" id="orderDetails" class="form-control" rows="4" placeholder="Type here..." maxlength="300" required v-model="reportMessage" style="line-height: 20px; padding: 10px;"></textarea>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                                <button type="submit" class="btn btn-primary" data-bs-dismiss="modal">Report</button>
                            </div>

                            
                        </form>
                    </div>

                    
                </div>
            </div>
        </div>

</template>

<style scoped>
.shx {
    width: 1000px;
}

.shm {
    max-width: 100%;
    max-height: 500px;
    object-fit: cover;
}

.no-pad2 {
    margin-left: 30px;
    padding-left: 30px;
}

.profB {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
}

@media only screen and (max-width: 666px) {

    .shx {
        width: 350px;

    }

    .shm {
        max-width: 100%;
        max-height: 700px;
        object-fit: cover;
    }

    .no-pad2 {
        margin: 0;
        padding: 0;
    }

    .profB {
        border-radius: 0px;
    }

}
</style>

<script>

import SidebarBody from '@/components/SidebarBody.vue';
import SuggestionsBody from '@/components/SuggestionsBody.vue';
import HeaderBody from '@/components/HeaderBody.vue';
import FooterBody from '@/components/FooterBody.vue';
import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
import "../../node_modules/v3-infinite-loading/lib/style.css";
import FsLightbox from "fslightbox-vue";
import LvSkeleton from "lightvue/skeleton";
import LvCodeLoader from 'lightvue/skeleton/preset/CodeLoader';

import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import Compressor from 'compressorjs';

import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, arrayRemove, setDoc, Timestamp } from "firebase/firestore";
import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { getAuth, onAuthStateChanged, signOut, EmailAuthProvider, reauthenticateWithCredential, signInWithEmailAndPassword } from "firebase/auth"
import { db } from '@/firebase';
import axios from 'axios';
import router from '@/router';
import { MD5 } from 'md5-js-tools';

export default {

    components: {
        SidebarBody,
        SuggestionsBody,
        HeaderBody,
        FooterBody,
        InfiniteLoading,
        FsLightbox,
        LvSkeleton,
        LvCodeLoader,
    },

    data() {
        return {
            toggler: false,
            loadingText: "",
            errorText: "",
            successText: "",
            successText2: "",

            bundle1: "",
            bundle2: "",
            bundle3: "",
            bundle1D: "",
            bundle2D: "",
            bundle3D: "",

            lastDocSnapshot: null,
            lastDocSnapshot2: null,

            profileBack: "",
            profilePic: "",
            userName: "",
            displayName: "",
            phone: "",
            email:"",
            sexuality: "",
            postCount: "",
            mediaCount: "",
            
            bio: "",
            facebook: "",
            instagram: "",
            twitter: "",
            snap: "",
            facebookLink: "",
            instagramLink: "",
            twitterLink: "",
            snapLink: "",
            userType: "",

            fanCount: "",
            followersCount: "",
            followingCount: "",
            likes: "",

            isFollower: false,
            isFollowing: false,
            isSubscribed: false,
            isFan: false,
            isOwner: false,

            subsList: [],
            followersList: [],
            followingList: [],
            postsList: [],
            postsMediaList: [],

            spamCount: 0,

            days: "",
            price: "",
            priceD: "",

            mUsername: "",

            tip: "",
            message: "",

            modelUsername: "",
            mediaList: "",
            mediaName: "",
            mediaSize: "",
            mediaType: "",
            mediaUrl: "",

            commentPic: "",
            commentCount: "",
            comments: [],
            commentInput: "",
            postIndex: "",

            likeSpamList: [],
            bookSpamList: [],

            unfUsername: "",
            unfUserId: "",

            tipPostId: "",

            subDescription: "",

            xxDuration: "",
            xxPrice: "",
            xxPriceD: "",

            ppvPost: "",
            password: "",

            profileType: "",
            noUserName: "",

            postId: "",
            toastMessage: "",
            reportReason: "Violates Baesnap Terms of Service",
            reportMessage: "",
            rPostId: "",
            reportCount: 0,

            userType: "",
            upline: "",
            uplineUserId: "",
            refCut: "",
            dateJoined: "",
            sexuality: "",
            modelId: "",

            videoObserver: null
        }
    },

    mounted() {

        document.body.style.overflowY = 'scroll';

        document.getElementById("mobileLogo").style.display = 'none';
        document.getElementById("mobileTitle").textContent = 'Profile';


        document.getElementById("moreN").classList.add("active");
        document.getElementById("moreN2").classList.add("active");

        this.getStart();
        this.getRefCut();

        this.videoObserver = new MutationObserver(() => {
            this.hideDownloadButtons()
        })

        this.videoObserver.observe(document.body, {
            childList: true,
            subtree: true
        })

    },

    unmounted(){
        if(sessionStorage.getItem("noUserName") == "noUserName" || this.noUserName == "noUserName"){
            const auth = getAuth();
            signOut(auth).then(() => {
                sessionStorage.clear();
                this.$router.push({ name: 'sign-in' });
                return;
            })
        }
    },

    beforeUnmount(){
        if (this.videoObserver) {
            this.videoObserver.disconnect()
        }
    },

    methods: {

        async getRefCut(){
            const userRef = doc(db, "AdminInfo", "info");
            const userSnap = await getDoc(userRef);
            let rc = userSnap.data().refCut;
            this.refCut = Number(rc);

        },

        hideDownloadButtons() {
            document.querySelectorAll('.fslightbox-container video').forEach(video => {
                video.setAttribute('controlsList', 'nodownload')
                video.setAttribute('disablePictureInPicture', '')
                video.oncontextmenu = () => false
            })
        },

        postClick(postId){

                this.$router.push({ name: 'post', params: { id: postId } });
                return;

        },

        reportClick(postId){
            this.rPostId = postId;
        },

        showToast(){
            $(".toast").each(function () {
                let eachItem = $(this), eachItemId = eachItem.data("id");

                if (eachItemId) {
                    new bootstrap.Toast($(this)).show();
                }
            });
        },

        async report(){

                this.reportCount++

                if(this.reportCount > 4){
                    return;
                }

                this.loadingText = "Reporting post";
                this.$refs.loadingModal.classList.add("bg-active");

                //add report
                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs;

                const auth = getAuth();

                await addDoc(collection(db, "UserReports"), {
                        
                    title: this.reportReason,
                    message: this.reportMessage,
                    postId: this.rPostId,
                    status: "pending",
                    userId: auth.currentUser.uid,
                    fullName: sessionStorage.getItem("fullName"),
                    email: sessionStorage.getItem("email"),
                    username: sessionStorage.getItem("userName"),
                    profilePic: sessionStorage.getItem("profilePic"),
                });

                this.toastMessage = "Post reported successfully!";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.showToast();

        },

        sharePost(postId){
                if(navigator.share){
                    navigator.share({
                        text: "Check out my post on Baesnap",
                        url: "https://app.baesnap.com/post/"+postId,
                        title: "Baesnap | Post"
                    })
                }
                else{
                        navigator.clipboard.writeText("https://app.baesnap.com/post/"+postId)
                }
        },

        copy(postId){
            this.toastMessage = "Link copied successfully!"
            let link = "https://app.baesnap.com/post/"+postId;
            navigator.clipboard.writeText(link);
            this.showToast(); 

        },

        closeSub() {
            this.$refs.subModal.classList.remove("bg-active");
        },

        closeE() {
            this.$refs.errorModal.classList.remove("bg-active");
        },

        openMessage(){
            let id = sessionStorage.getItem("otherId");
            sessionStorage.setItem("peerUserId", id);
            sessionStorage.setItem("peerFullname", this.displayName);
            sessionStorage.setItem("peerUsername", this.userName);
            sessionStorage.setItem("peerProfilePic", this.profilePic);
            this.$router.push({name: 'messages'})
        },

        closeS() {
            this.$refs.successModal.classList.remove("bg-active");
            this.$router.go();
        },

        closeS2() {
            this.$refs.successModal2.classList.remove("bg-active");
        },

        getOccurrence(array, value) {
            var count = 0;
            array.forEach((v) => (v === value && count++));
            return count;
        },

        fileSizeFormat(fileSize) {
            let mSize;
            if (Number(fileSize) >= 1073741824) {
                mSize = (Number(fileSize) / 1073741824).toFixed(2) + " GB";
            }
            else if (Number(fileSize) >= 1048576) {
                mSize = (Number(fileSize) / 1048576).toFixed(2) + " MB";
            }
            else if (Number(fileSize) >= 1024) {
                mSize = (Number(fileSize) / 1024).toFixed(2) + " KB";
            }

            return mSize;
        },

        closeShow() {
            this.mediaName = "";
            this.mediaType = "";
            this.mediaUrl = "";
            this.mediaSize = "";
            this.$refs.showModal.classList.remove("bg-active");
            return;

        },

        kFormatter(num) {
            return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num);

        },

        timeFormat(date) {

            let newFormat;

            TimeAgo.addDefaultLocale(en);
            const timeAgo = new TimeAgo('en-US');
            newFormat = timeAgo.format(Number(date));

            return newFormat;

        },

        async commentClick(post, index) {

            this.commentCount = post.commentCount;
            this.postId = post.id;
            this.postIndex = index;

            this.comments = [];
            this.commentInput = "";

            const q = query(collection(db, "UserPosts", this.postId, "Comments"), orderBy("dateN"), limit(20));
            const querySnapshot = await getDocs(q);

            querySnapshot.forEach((doc) => {
                this.comments.push({
                    userId: doc.data().userId,
                    profilePic: doc.data().profilePic,
                    name: doc.data().name,
                    userName: sessionStorage.getItem("userName"),
                    comment: doc.data().comment,
                    date: doc.data().date,
                });
            });


        },

        async likeClick(id, index, post) {

            const auth = getAuth();

            this.likeSpamList.push(post.id);


            $("#" + id).toggleClass("text-danger bg-danger-4 hp-bg-color-dark-danger");
            $("#" + id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

            //update list
            if (post.isLiked) {
                this.postsList[index].likeCount--;
                this.postsList[index].isLiked = false;

                if (this.getOccurrence(this.likeSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    likeCount: increment(-1),

                });

                const userRef = doc(db, "Users", post.userId);
                await updateDoc(userRef, {
                    likes: increment(-1),
                    likesN: increment(1)
                });

                await deleteDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid));
                await deleteDoc(doc(db, "UserLikes", auth.currentUser.uid, "likedList", post.id));
            }

            else {
                this.postsList[index].likeCount++;
                this.postsList[index].isLiked = true;

                if (this.getOccurrence(this.likeSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    likeCount: increment(1),

                });

                const userRef = doc(db, "Users", post.userId);
                await updateDoc(userRef, {
                    likes: increment(1),
                    likesN: increment(-1)
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs;

                await setDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                await setDoc(doc(db, "UserLikes", auth.currentUser.uid, "LikedList", post.id), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                // NOTIFICATION
                if (post.userId != auth.currentUser.uid) {

                    const notiRef = doc(db, "Users", post.userId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    await addDoc(collection(db, "UserNoti"), {
                        category: "Likes",
                        description: "Liked your post",
                        ownerId: post.userId,
                        userId: auth.currentUser.uid,
                        username: sessionStorage.getItem("userName"),
                        fullName: sessionStorage.getItem("fullName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        email: sessionStorage.getItem("email"),
                        date: serverTimestamp(),
                        postId: post.id,
                        dateN: secs
                    });

                }
            }

        },

        async bookClick(id, index, post) {

            $("#" + id).toggleClass("text-primary bg-primary-4 hp-bg-color-dark-primary");
            $("#" + id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

            const auth = getAuth();
            this.bookSpamList.push(post.id);

            //update list
            if (post.isBookmarked) {
                this.postsList[index].bookmarkCount--;
                this.postsList[index].isBookmarked = false;

                if (this.getOccurrence(this.bookSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    bookmarkCount: increment(-1),

                });

                //remove bookmark post
                await deleteDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid));
                await deleteDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id));
            }

            else {
                this.postsList[index].bookmarkCount++;
                this.postsList[index].isBookmarked = true;

                if (this.getOccurrence(this.bookSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    bookmarkCount: increment(1),

                });

                //add post to bookmark
                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                //add post to bookmark
                await setDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                await setDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                // NOTIFICATION
                if (post.userId != auth.currentUser.uid) {

                    const notiRef = doc(db, "Users", post.userId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs
                    await addDoc(collection(db, "UserNoti"), {
                        category: "Bookmarks",
                        description: "Bookmarked your post",
                        ownerId: post.userId,
                        userId: auth.currentUser.uid,
                        username: sessionStorage.getItem("userName"),
                        fullName: sessionStorage.getItem("fullName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        email: sessionStorage.getItem("email"),
                        date: serverTimestamp(),
                        postId: post.id,
                        dateN: secs
                    });

                }
            }
        },

        ppvClick(post){
            this.ppvPost = post;
            $('#ppv').modal('show');
        },

        ppv(){

            this.loadingText = "Authenticating...";
            this.$refs.loadingModal.classList.add("bg-active");

            
            if(this.password == ""){
                this.errorText = "Please enter your password to proceed.";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }

            let passwordHash = MD5.generate(String(this.password));

            const auth = getAuth();
            const user = auth.currentUser;

            if(this.ppvPost.userId == auth.currentUser.uid){
                return;
            }

            const credential = EmailAuthProvider.credential( sessionStorage.getItem("email"), passwordHash );

            reauthenticateWithCredential(user, credential)
            .then((result) => {
                //password correct
                this.ppv2();

            })
            .catch((error) => {
                //console.log(error);
                this.errorText = "Incorrect password...";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;

            });
        },

        async ppv2(){
            let balance, newBalance, uFullname, uEmail, uUsername, uProfilePic;

            const auth = getAuth();
            this.loadingText = "Processing transaction...";

            //check balance
            const userRef = doc(db, "Users", auth.currentUser.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                balance = userSnap.data().balance;
                uFullname = userSnap.data().name;
                uUsername = userSnap.data().displayId;
                uProfilePic = userSnap.data().profilePic;
                uEmail = userSnap.data().email;

                if (balance < this.ppvPost.price) {
                    this.errorText = "Insufficient balance. Please top up your account and try again.";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }
            }
            else {
                this.$router.push({ name: 'sign-in' });
                return;
            }

            await updateDoc(userRef, {
                balance: increment(-this.ppvPost.price),
            });

            //update model balance
            const modelRef = doc(db, "Users", this.ppvPost.userId);
            await updateDoc(modelRef, {
                earnings: increment(this.ppvPost.price),
                ppvBalance: increment(this.ppvPost.price),
            });

            //add to paidUsers
            await setDoc(doc(db, "UserPosts", this.ppvPost.id, "PaidUsers", auth.currentUser.uid), {});

            let mSecs = new Date().getTime() / 1000;
            let transSecs = 10000000000 / mSecs;

            //update user transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBW" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Withdrawal",
                title: "Paid post",
                description: " Paid to view post",
                amount: this.ppvPost.price,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: transSecs,
                status: "successful",
                userId: auth.currentUser.uid,
                fullName: this.ppvPost.fullName,
                username: this.ppvPost.userName,
                profilePic: this.ppvPost.profilePic,
            });

            //update model transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBD" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Deposit",
                title: "Paid post",
                description: "@" + uUsername + " paid to view your post",
                amount: this.ppvPost.price,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: transSecs,
                status: "successful",
                userId: this.ppvPost.userId,
                
                username: uUsername,
                fullName: uFullname,
                profilePic: uProfilePic,

            });

            // NOTIFICATION
            if (this.ppvPost.userId != auth.currentUser.uid) {

                const notiRef = doc(db, "Users", this.ppvPost.userId);
                await updateDoc(notiRef, {
                    notiCount: increment(1),
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                await addDoc(collection(db, "UserNoti"), {
                    category: "Paid posts",
                    description: "Paid for your post",
                    ownerId: this.ppvPost.userId,
                    userId: auth.currentUser.uid,
                    username: uUsername,
                    fullName: uFullname,
                    profilePic: uProfilePic,
                    email: uEmail,
                    date: serverTimestamp(),
                    dateN: secs,
                    postId: this.ppvPost.id,
                });

            }

            axios.post('https://api.baesnap.com/v1/new-ppv-mail', {
                toName: this.ppvPost.fullName,
                toEmail: this.ppvPost.email,
                username: "@" + uUsername,
                amount: this.ppvPost.priceD,
                
            })
            .then(function (response) {
                //console.log(response);
            })

            $('#ppv').modal('hide');

            this.successText = "The transaction was completed successfully. You now have full access to the post.";
            this.$refs.successModal.classList.add("bg-active");
            this.$refs.loadingModal.classList.remove("bg-active");

        },

        async postComment() {

            const auth = getAuth();

            if(auth.currentUser.uid == null){
                return;
            }

            this.commentCount++;

            let a = String(new Date());

            let mSecs = new Date().getTime() / 1000;
            let secs = 10000000000 / mSecs;

            //update list
            let commentObj = {
                userId: auth.currentUser.uid,
                profilePic: sessionStorage.getItem("profilePic"),
                name: sessionStorage.getItem("fullName"),
                userName: sessionStorage.getItem("userName"),
                comment: this.commentInput,
                date: a.slice(0, -36),
                dateN: secs
            }

            this.comments.unshift(commentObj);
            document.getElementById("comDiv").scrollIntoView();

            //update post comment db
            const postRef = doc(db, "UserPosts", this.postId);
            await updateDoc(postRef, {

                commentCount: increment(1),

            });

            await addDoc(collection(db, "UserPosts", this.postId, "Comments"), {
                userId: auth.currentUser.uid,
                profilePic: sessionStorage.getItem("profilePic"),
                name: sessionStorage.getItem("fullName"),
                userName: sessionStorage.getItem("userName"),
                comment: this.commentInput,
                date: a.slice(0, -36),
                dateN: secs
            });

            this.commentInput = "";
            this.postsList[this.postIndex].commentCount++;

            // NOTIFICATION
            if (sessionStorage.getItem("otherId") != auth.currentUser.uid) {

                const notiRef = doc(db, "Users", sessionStorage.getItem("otherId"));
                await updateDoc(notiRef, {
                    notiCount: increment(1),
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                await addDoc(collection(db, "UserNoti"), {
                    category: "Comments",
                    description: "Commented on your post: " + this.commentInput,
                    ownerId: sessionStorage.getItem("otherId"),
                    userId: auth.currentUser.uid,
                    username: sessionStorage.getItem("userName"),
                    fullName: sessionStorage.getItem("fullName"),
                    profilePic: sessionStorage.getItem("profilePic"),
                    email: sessionStorage.getItem("email"),
                    date: serverTimestamp(),
                    dateN: secs,
                    postId: this.postId,
                });

            }

        },

        galleryBtnClick(post) {

            this.mediaUrl = post.mediaList[0].url;
            this.mediaType = post.mediaList[0].type;
            this.modelUsername = post.userName;
            this.mediaList = post.mediaList;
        },

        playMedia(media) {

            this.mediaName = media.name;
            this.mediaType = media.type;
            this.mediaUrl = media.url;
            this.mediaSize = media.size
            //this.$refs.showModal.classList.add("bg-active");

        },

        share(){
            if(navigator.share){
                navigator.share({
                    text: "",
                    url: "https://app.baesnap.com/profiles/"+this.userName,
                    title: "Baesnap | "+this.userName
                })
            }
            else{
                    navigator.clipboard.writeText("https://app.baesnap.com/profiles/"+this.userName)
            }
        },

        getStart(){
            const auth = getAuth();
            if(sessionStorage.getItem("userName") == null){

                signInWithEmailAndPassword(auth, "forgot@baesnap.com", "forgotPassword")
                .then( async (data) => {
                    this.noUserName = "noUserName";
                    sessionStorage.setItem("noUserName", "noUserName");
                })

            };

            this.getUserInfo();
        },

        async getUserInfo() {

            this.loadingText = "Getting user info...";
            this.$refs.loadingModal.classList.add("bg-active");

            let userId;

            //get userId
            let userName = this.$route.params.id;

            if(userName == sessionStorage.getItem("userName")){
                this.$router.push({name: 'profile'});
                return;
            }

            const q = query(collection(db, "Users"), where("displayId", "==", userName.toLowerCase()));

            const querySnapshot = await getDocs(q);
            if(querySnapshot.docs.length > 0){
                
                querySnapshot.forEach((doc) => {
                    userId = doc.id
                    sessionStorage.setItem("otherId", userId)
                    sessionStorage.setItem("otherUserName", userName.toLowerCase())

                    localStorage.setItem("otherId", userId);
                    localStorage.setItem("otherUserName", userName.toLowerCase())
                })
                
            }
            else{
                this.errorText = "Sorry, this user does not exist";
                this.$refs.errorModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");

                this.$router.push({ name: 'home' });
                return
            }

            if(userId == null){
                this.$router.push({ name: 'home' });
                return;
            }

            const userRef = doc(db, "Users", userId);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                this.profileBack = userSnap.data().profileBackground;
                this.profilePic = userSnap.data().profilePic;
                this.displayName = userSnap.data().name;
                this.userName = userSnap.data().displayId;
                this.phone = userSnap.data().phone;
                this.fanCount = userSnap.data().fanCount;
                this.followersCount = userSnap.data().followersCount;
                this.followingCount = userSnap.data().followingCount;
                this.likes = userSnap.data().likes;
                this.userType = userSnap.data().type;
                this.email = userSnap.data().email;
                this.bio = userSnap.data().bio;
                this.facebook = userSnap.data().facebookLink;
                this.instagram = userSnap.data().instagramLink;
                this.twitter = userSnap.data().twitterLink;
                this.snap = userSnap.data().snapLink;
                
                this.facebookLink = "https://tiktok.com/@" + userSnap.data().facebookLink;
                this.instagramLink = "https://instagram.com/" + userSnap.data().instagramLink;
                this.twitterLink = "https://x.com/" + userSnap.data().twitterLink;
                this.snapLink = "https://www.snapchat.com/add/"+userSnap.data().snapLink;
                this.bundle1 = userSnap.data().bundle1;
                this.bundle2 = userSnap.data().bundle2;
                this.bundle3 = userSnap.data().bundle3;
                this.sexuality = userSnap.data().sexuality;

                this.postCount = userSnap.data().postCount,
                this.mediaCount = userSnap.data().mediaCount,

                this.bundle1D = Number(userSnap.data().bundle1).toLocaleString("us-US");
                this.bundle2D = Number(userSnap.data().bundle2).toLocaleString("us-US");
                this.bundle3D = Number(userSnap.data().bundle3).toLocaleString("us-US");

                this.subDescription = userSnap.data().subDescription;

                this.profileType = userSnap.data().profileType;

                this.dateJoined = userSnap.data().dateJoined.seconds;
                this.upline = userSnap.data().upline;
                this.userType = userSnap.data().type;
                this.modelId = userSnap.data().userId;

            }
            else {
                this.errorText = "Sorry, this user does not exist";
                this.$refs.errorModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");

                this.$router.push({ name: 'home' });
                return;
            }

            this.getFollowersList();
            this.getFollowingList();
            this.getSubsList();
            this.getFansList();
            this.$refs.loadingModal.classList.remove("bg-active");

        },

        async getFollowersList() {

            const auth = getAuth();
            const querySnapshot = await getDocs(collection(db, "UserFollowers", auth.currentUser.uid, "Followers"));

            if (querySnapshot.docs.length > 0) {

                querySnapshot.forEach((doc) => {
                    //this.followersList.push(doc.id);
                    if (doc.id == sessionStorage.getItem("otherId")) {
                        this.isFollower = true;
                        return;
                    }
                });

                // for(let i=0; i < this.followersList.length ; i++){
                //     if(this.followersList[i] == sessionStorage.getItem("otherId")){
                //         this.isFollower = true;
                //         return;
                //     }
                // }

                // this.isFollower = false;
            }

            else {
                this.isFollower = false;
            }



        },

        async getFollowingList() {

            const auth = getAuth();
            const querySnapshot = await getDocs(collection(db, "UserFollowing", auth.currentUser.uid, "Following"));

            if (querySnapshot.docs.length > 0) {

                querySnapshot.forEach((doc) => {
                    //this.followingList.push(doc.id)

                    if (doc.id == sessionStorage.getItem("otherId")) {
                        this.isFollowing = true;
                        return;
                    }

                });

                // for(let i=0; i < this.followingList.length ; i++){
                //     if(this.followingList[i] == sessionStorage.getItem("otherId")){
                //         this.isFollowing = true;
                //         return;
                //     }
                // }

                // this.isFollowing = false;

            }

            else {
                this.isFollowing = false;
            }

        },

        async getSubsList() {

            const auth = getAuth();
            const querySnapshot = await getDocs(collection(db, "UserSubs", auth.currentUser.uid, "Subs"));

            if (querySnapshot.docs.length > 0) {

                querySnapshot.forEach((doc) => {
                    if (doc.id == sessionStorage.getItem("otherId")) {
                        this.isSubscribed = true;
                        this.xxPrice = doc.data().price;
                        this.xxPriceD = Number(doc.data().price).toLocaleString("us-US");
                        return;
                    }
                });

                // for(let i=0; i < this.subsList.length ; i++){
                //     if(this.subsList[i] == sessionStorage.getItem("otherId")){
                //         this.isSubscribed = true;
                //         return;
                //     }
                // }

                // this.isSubscribed = false;

            }

            else {
                this.isSubscribed = false;
            }

            if (auth.currentUser.uid == sessionStorage.getItem("otherId")) {
                this.isOwner = true;
                this.isSubscribed = true;
            }
            else if (this.userType == "user") {
                this.isSubscribed = true;
            }
            



        },

        async getFansList() {

            const auth = getAuth();
            const querySnapshot = await getDocs(collection(db, "UserFans", auth.currentUser.uid, "Fans"));

            if (querySnapshot.docs.length > 0) {

                querySnapshot.forEach((doc) => {
                    if (doc.id == sessionStorage.getItem("otherId")) {
                        this.isFan = true;
                        return;
                    }
                });

                // for(let i=0; i < this.subsList.length ; i++){
                //     if(this.subsList[i] == sessionStorage.getItem("otherId")){
                //         this.isSubscribed = true;
                //         return;
                //     }
                // }

                // this.isSubscribed = false;

            }

            else {
                this.isFan = false;
            }

        },

        async followUser() {

            this.spamCount++;
            if (this.spamCount > 2) {
                return;
            }

            this.loadingText = "Following @" + this.userName + "...";
            this.$refs.loadingModal.classList.add("bg-active");

            const auth = getAuth();

            await setDoc(doc(db, "UserFollowing", auth.currentUser.uid, "Following", sessionStorage.getItem("otherId")), {
                userId: sessionStorage.getItem("otherId"),
                fullname: this.displayName,
                username: this.userName,
                profilePic: this.profilePic,
                timeStamp: serverTimestamp(),
            });
            const userRef = doc(db, "Users", auth.currentUser.uid);
            await updateDoc(userRef, {
                followingCount: increment(1),
            });

            await setDoc(doc(db, "UserFollowers", sessionStorage.getItem("otherId"), "Followers", auth.currentUser.uid), {
                userId: auth.currentUser.uid,
                fullname: sessionStorage.getItem("fullName"),
                username: sessionStorage.getItem("userName"),
                profilePic: sessionStorage.getItem("profilePic"),
                timeStamp: serverTimestamp(),
            });
            const userRef2 = doc(db, "Users", sessionStorage.getItem("otherId"));
            await updateDoc(userRef2, {
                followersCount: increment(1),
            });



            this.followersCount++;

            this.isFollowing = true;

            // NOTIFICATION
            if (sessionStorage.getItem("otherId") != auth.currentUser.uid) {

                const notiRef = doc(db, "Users", sessionStorage.getItem("otherId"));
                await updateDoc(notiRef, {
                    notiCount: increment(1),
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                await addDoc(collection(db, "UserNoti"), {
                    category: "Users",
                    description: "Started following you",
                    ownerId: sessionStorage.getItem("otherId"),
                    userId: auth.currentUser.uid,
                    username: sessionStorage.getItem("userName"),
                    fullName: sessionStorage.getItem("fullName"),
                    profilePic: sessionStorage.getItem("profilePic"),
                    email: sessionStorage.getItem("email"),
                    date: serverTimestamp(),
                    dateN: secs,
                    postId: "",
                });

            }

            //add them to my contact list
            await setDoc(doc(db, "UserContact", auth.currentUser.uid, "Contact", sessionStorage.getItem("otherId")), {
                userId: sessionStorage.getItem("otherId"),
                fullName: this.displayName,
                userName: this.userName,
                profilePic: this.profilePic,
                userType: this.userType,
            });

            //add me to their contact list
            await setDoc(doc(db, "UserContact", sessionStorage.getItem("otherId"), "Contact", auth.currentUser.uid), {
                userId: auth.currentUser.uid,
                fullName: sessionStorage.getItem("fullName"),
                userName: sessionStorage.getItem("userName"),
                profilePic: sessionStorage.getItem("profilePic"),
                userType: sessionStorage.getItem("userType"),
            });


            this.successText2 = "Successfully followed @" + this.userName + ". You can now send and receive messages from them.  ";
            this.$refs.successModal2.classList.add("bg-active");
            this.$refs.loadingModal.classList.remove("bg-active");

        },

        async unfollowUser() {

            this.spamCount++;
            if (this.spamCount > 2) {
                return;
            }

            this.loadingText = "Unfollowing @" + this.userName + "...";
            this.$refs.loadingModal.classList.add("bg-active");

            const auth = getAuth();

            await deleteDoc(doc(db, "UserFollowing", auth.currentUser.uid, "Following", sessionStorage.getItem("otherId")));
            const userRef = doc(db, "Users", auth.currentUser.uid);
            await updateDoc(userRef, {
                followingCount: increment(-1),
            });

            await deleteDoc(doc(db, "UserFollowers", sessionStorage.getItem("otherId"), "Followers", auth.currentUser.uid));
            const userRef2 = doc(db, "Users", sessionStorage.getItem("otherId"));
            await updateDoc(userRef2, {
                followersCount: increment(-1),
            });

            this.followersCount--;

            this.isFollowing = false;


            if (!this.isSubscribed && !this.isFan) {
                try {
                    await deleteDoc(doc(db, "UserContact", auth.currentUser.uid, "Contact", sessionStorage.getItem("otherId")));
                }
                catch (err) {
                    console.log(err)
                }

                try {
                    await deleteDoc(doc(db, "UserContact", sessionStorage.getItem("otherId"), "Contact", auth.currentUser.uid));
                }
                catch (err) {
                    console.log(err)
                }
            }


            this.successText2 = "Successfully unfollowed @" + this.userName + "";
            this.$refs.successModal2.classList.add("bg-active");
            this.$refs.loadingModal.classList.remove("bg-active");

        },

        subClick(days, price) {
            this.days = days;
            this.price = price;
            this.priceD = price.toLocaleString("us-US");
            this.$refs.subModal.classList.add("bg-active");

        },

        subClick2() {
            this.$router.push({name: 'sub-pay'});

        },

        subClick3() {
            this.$router.push({name: 'sign-in'});

        },

        async subscribe() {

            let balance, newBalance, uFullname, uEmail, uProfilePic;

            const auth = getAuth();

            this.loadingText = "Subscribing to @" + this.userName + "...";
            this.$refs.loadingModal.classList.add("bg-active");

            //check balance
            const userRef = doc(db, "Users", auth.currentUser.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                balance = userSnap.data().balance;
                this.mUsername = userSnap.data().displayId;
                uFullname = userSnap.data().name,
                    uProfilePic = userSnap.data().profilePic;
                uEmail = userSnap.data().email;

                if (balance < this.price) {
                    this.errorText = "Insufficient balance. Please top up your account and try again.";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }
            }
            else {
                this.$router.push({ name: 'sign-in' });
                return;
            }

            let todaySecs = Timestamp.now().seconds;
            let durationSecs = this.days * 86400;
            let endDateSecs = todaySecs + durationSecs;

            newBalance = balance - this.price;

            await updateDoc(userRef, {
                balance: newBalance,
            });

            //update model balance
            const modelRef = doc(db, "Users", sessionStorage.getItem("otherId"));
            await updateDoc(modelRef, {
                earnings: increment(this.price),
                fanCount: increment(1),
                fanCountN: increment(-1)
            });

            //update model fan list
            await setDoc(doc(db, "UserFans", sessionStorage.getItem("otherId"), "Fans", auth.currentUser.uid,), {
                price: this.price,
                startDate: serverTimestamp(),
                duration: this.days,
                endDate: endDateSecs,
                status: "active",
                userId: auth.currentUser.uid,
                username: this.mUsername,
                fullName: uFullname,
                profilePic: uProfilePic,
                email: uEmail,
            });

            await setDoc(doc(db, "UserSubs", auth.currentUser.uid, "Subs", sessionStorage.getItem("otherId")), {
                price: this.price,
                startDate: serverTimestamp(),
                duration: this.days,
                endDate: endDateSecs,
                status: "active",
                modelId: sessionStorage.getItem("otherId"),
                modelName: this.displayName,
                modelUserName: this.userName,
                modelProfilePic: this.profilePic,
                email: uEmail,
            });

            let mSecs = new Date().getTime() / 1000;
            let transSecs = 10000000000 / mSecs

            //update user transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBW" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Withdrawal",
                title: "Subscription",
                description: " Subscribed to @" + this.userName + " for " + this.days + " days",
                amount: this.price,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: transSecs,
                status: "successful",
                userId: auth.currentUser.uid,
                fullName: this.displayName,
                username: this.userName,
                profilePic: this.profilePic,
            });

            //update model transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBD" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Deposit",
                title: "Subscription",
                description: "@" + this.mUsername + " subscribed to your account for " + this.days + " days",
                amount: this.price,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: transSecs,
                status: "successful",
                userId: sessionStorage.getItem("otherId"),
                username: this.mUsername,
                fullName: uFullname,
                profilePic: uProfilePic,

            });

            // NOTIFICATION
            if (sessionStorage.getItem("otherId") != auth.currentUser.uid) {

                const notiRef = doc(db, "Users", sessionStorage.getItem("otherId"));
                await updateDoc(notiRef, {
                    notiCount: increment(1),
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                await addDoc(collection(db, "UserNoti"), {
                    category: "Subs",
                    description: "Subscribed to your content for " + this.days + " at ₦ " + this.price,
                    ownerId: sessionStorage.getItem("otherId"),
                    userId: auth.currentUser.uid,
                    username: sessionStorage.getItem("userName"),
                    fullName: uFullname,
                    profilePic: uProfilePic,
                    email: uEmail,
                    date: serverTimestamp(),
                    dateN: secs,
                    postId: "",
                });

            }

            //add them to my contact list
            await setDoc(doc(db, "UserContact", auth.currentUser.uid, "Contact", sessionStorage.getItem("otherId")), {
                userId: sessionStorage.getItem("otherId"),
                fullName: this.displayName,
                userName: this.userName,
                profilePic: this.profilePic,
                userType: this.userType,
            });

            //add me to their contact list
            await setDoc(doc(db, "UserContact", sessionStorage.getItem("otherId"), "Contact", auth.currentUser.uid), {
                userId: auth.currentUser.uid,
                fullName: sessionStorage.getItem("fullName"),
                userName: sessionStorage.getItem("userName"),
                profilePic: sessionStorage.getItem("profilePic"),
                userType: sessionStorage.getItem("userType"),
            });

            axios.post('https://api.baesnap.com/v1/new-sub-mail', {
                toName: this.displayName,
                toEmail: this.email,
                username: "@" + sessionStorage.getItem("userName"),
                amount: Number(this.price).toLocaleString("us-Us"),
                duration: this.days,
            })
                .then(function (response) {
                    console.log(response);

                })

            this.successText = "Successfully Subscribed to @" + this.userName + " for " + this.days + " days";
            this.$refs.successModal.classList.add("bg-active");
            this.$refs.loadingModal.classList.remove("bg-active");

            this.isSubscribed = true;

        },

        async sendTip() {

            let balance, newBalance, uFullname, uEmail, uProfilePic;

            this.loadingText = "Sending tip...";
            this.$refs.loadingModal.classList.add("bg-active");

            if (this.tip < 100) {
                this.errorText = "Minimum amount for tips is ₦ 100";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }

            if (this.tip > 500000) {
                this.errorText = "Tips can not be larger than ₦ 500,000";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }

            //check balance
            const auth = getAuth();
            const userRef = doc(db, "Users", auth.currentUser.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                balance = userSnap.data().balance;
                this.mUsername = userSnap.data().displayId;
                uFullname = userSnap.data().name,
                    uProfilePic = userSnap.data().profilePic;
                uEmail = userSnap.data().email;

                if (balance < this.tip) {
                    this.errorText = "Insufficient balance. Please top up your account and try again.";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }
            }
            else {
                this.$router.push({ name: 'sign-in' });
                return;
            }

            newBalance = balance - this.tip;

            await updateDoc(userRef, {
                balance: newBalance,
            });

            const modelRef = doc(db, "Users", sessionStorage.getItem("otherId"));
            await updateDoc(modelRef, {
                earnings: increment(this.tip),
                tipBalance: increment(this.tip),
            });

            const q = query(collection(db, "Users"), where("refCode", "==", this.upline));
            const idSnapshot = await getDocs(q);
            if(idSnapshot.docs.length > 0){
                idSnapshot.forEach((doc) => {
                    this.uplineUserId = doc.id;
                });

            }

            let mSecs = new Date().getTime() / 1000;
            let transSecs = 10000000000 / mSecs

            //update user transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBW" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Withdrawal",
                title: "Sent tip",
                description: " Sent a tip of ₦ " + this.tip + " to @" + this.userName,
                amount: this.tip,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: transSecs,
                status: "successful",
                userId: auth.currentUser.uid,
                fullName: this.displayName,
                username: this.userName,
                profilePic: this.profilePic,
            });

            //update model transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBD" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Deposit",
                title: "Received tip",
                description: "@" + this.mUsername + " sent a tip of ₦ " + this.tip + " ",
                amount: this.tip,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: transSecs,
                status: "successful",
                userId: sessionStorage.getItem("otherId"),
                
                username: this.mUsername,
                fullName: uFullname,
                profilePic: uProfilePic,

            });

            // NOTIFICATION
            if (sessionStorage.getItem("otherId") != auth.currentUser.uid) {

                const notiRef = doc(db, "Users", sessionStorage.getItem("otherId"));
                await updateDoc(notiRef, {
                    notiCount: increment(1),
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                await addDoc(collection(db, "UserNoti"), {
                    category: "Tips",
                    description: "Sent you a tip of ₦ " + this.tip,
                    ownerId: sessionStorage.getItem("otherId"),
                    userId: auth.currentUser.uid,
                    username: this.mUsername,
                    fullName: uFullname,
                    profilePic: uProfilePic,
                    email: uEmail,
                    date: serverTimestamp(),
                    dateN: secs,
                    postId: "",
                });

            }

            if(this.message == ""){
                this.message = "none";
            }

            axios.post('https://api.baesnap.com/v1/tip-mail', {
                    toName: this.displayName,
                    toEmail: this.email,
                    username: sessionStorage.getItem("userName"),
                    amount: Number(this.tip).toLocaleString("us-Us"),
                    message: this.message
                })
                .then(function (response) {
                    console.log(response);
                    
                })


            //REFF
            //check ref endDate
            let dateJoinedMili = Number(this.dateJoined) * 1000;
            let todayMili = Timestamp.now().seconds * 1000;

            let refDays = Math.round((todayMili - dateJoinedMili) / (1000 * 60 * 60 * 24));

            if(Number(refDays) < 365 && this.upline != ""){

                    if(this.uplineUserId == auth.currentUser.uid){
                        
                        $('#sendTip').modal('hide');
                        this.successText2 = "Tip sent successfully";
                        this.$refs.successModal2.classList.add("bg-active");
                        this.$refs.loadingModal.classList.remove("bg-active");

                        return;
                    }

                    //update upline ref balance
                    let mRefCut = this.refCut/100;
                    let refAmount = Number(this.tip) * mRefCut;

                    const usersRef = doc(db, "Users", this.uplineUserId);
                    await updateDoc(usersRef, {
                        
                        refBalance: increment(refAmount),
                        
                    });

                    //update upline ref user
                    const refUserRef = doc(db, "Referrals", this.modelId);
                    await updateDoc(refUserRef, {
                        
                        refBalance: increment(refAmount),
                        
                    });

                    let mSecs = Timestamp.now().seconds;
                    let secs = 10000000000 / mSecs;
                    
                    //update upline refTrans
                    await addDoc(collection(db, "RefTrans"), {
                        type: "Deposit",
                        refAmount: refAmount,

                        fullName: this.displayName,
                        userName: this.userName,
                        profilePic: this.profilePic,
                        email: this.email,
                        userType: this.userType,
                        sexuality: this.sexuality,
                        userId: this.modelId,
                        timeStamp: serverTimestamp(),
                        timeStampN: secs,

                        status: "successful",
                        ownerId: this.uplineUserId
                    });

            }
            

            $('#sendTip').modal('hide');
            this.successText2 = "Tip sent successfully";
            this.$refs.successModal2.classList.add("bg-active");
            this.$refs.loadingModal.classList.remove("bg-active");

        },

        async getFullName(id, userId, mediaList, previewUrl, mIndex) {

            let i = mIndex;
            let fanList = [];
            let likedList = [];
            let bookmarkList = [];
            let paidUsers = [];

            let urlList = [];
            let imgCount = 0;
            let vidCount = 0;

            for (let a = 0; a < mediaList.length; a++) {
                urlList.push(mediaList[a].url)
                if (mediaList[a].type.startsWith("image")) {
                    imgCount++;
                }
                else if (mediaList[a].type.startsWith("video")) {
                    vidCount++;
                }
            }

            if(mediaList.length < 1){
                urlList.push(previewUrl);
            }

            const auth = getAuth();

            const querySnapshot = await getDocs(collection(db, "UserFans", userId, "Fans"));
            querySnapshot.forEach((doc) => {
                fanList.push(doc.id);
            });

            const querySnapshot2 = await getDocs(collection(db, "UserPosts", id, "LikedList"));
            querySnapshot2.forEach((doc) => {
                likedList.push(doc.id);
            });

            const querySnapshot3 = await getDocs(collection(db, "UserPosts", id, "BookmarkList"));
            querySnapshot3.forEach((doc) => {
                bookmarkList.push(doc.id);
            });

            const querySnapshot4 = await getDocs(collection(db, "UserPosts", id, "PaidUsers"));
            querySnapshot4.forEach((doc) => {
                paidUsers.push(doc.id);
            });

            if (this.postsList[i].id == id) {

                    this.postsList[i].urlList = urlList;
                        this.postsList[i].vidCount = vidCount;
                        this.postsList[i].imgCount = imgCount;

                    for (let b = 0; b < likedList.length; b++) {
                        if (likedList[b] == auth.currentUser.uid) {
                            this.postsList[i].isLiked = true;
                            break;
                        }
                    }

                    for (let c = 0; c < bookmarkList.length; c++) {
                        if (bookmarkList[c] == auth.currentUser.uid) {
                            this.postsList[i].isBookmarked = true;
                            break;
                        }
                    }

                    for (let e = 0; e < paidUsers.length; e++) {
                        if (paidUsers[e] == auth.currentUser.uid) {
                            this.postsList[i].isPaid = true;
                            break;
                        }
                    }

                    if(this.userType == "user" ||  this.isSubscribed || this.profileType == "free" ){
                        this.postsList[i].isSubscribed = true;
                    }
                    // else {
                    //     for (let j = 0; j < fanList.length; j++) {
                    //         if (fanList[j] == auth.currentUser.uid) {
                    //             this.postsList[i].isSubscribed = true;
                    //             break;
                    //         }
                    //     }
                    // }

                    this.postsList[i].isLoading = false;

                }

        },

        async getFullName2(id, userId) {

            let index;
            let fanList = [];
            let likedList = [];
            let bookmarkList = [];
            let paidUsers = [];

            const auth = getAuth();
            const userRef = doc(db, "Users", userId);
            const userSnap = await getDoc(userRef);

            // const querySnapshot = await getDocs(collection(db, "UserFans", userId, "Fans"));
            // querySnapshot.forEach((doc) => {
            //     fanList.push(doc.id);
            // });

            // const querySnapshot2 = await getDocs(collection(db, "UserPosts", id, "LikedList"));
            // querySnapshot2.forEach((doc) => {
            //     likedList.push(doc.id);
            // });

            // const querySnapshot3 = await getDocs(collection(db, "UserPosts", id, "BookmarkList"));
            // querySnapshot3.forEach((doc) => {
            //     bookmarkList.push(doc.id);
            // });

            const querySnapshot4 = await getDocs(collection(db, "UserPosts", id, "PaidUsers"));
            querySnapshot4.forEach((doc) => {
                paidUsers.push(doc.id);
            });

            for (let i = 0; i < this.postsMediaList.length; i++) {
                if (this.postsMediaList[i].id == id) {
                    index = i;
                    // this.postsMediaList[i].fullName = userSnap.data().name;
                    // this.postsMediaList[i].userName = userSnap.data().displayId;
                    // this.postsMediaList[i].profilePic = userSnap.data().profilePic;

                    if (auth.currentUser.uid == userId) {
                        this.postsMediaList[i].isOwner = true;
                        this.postsMediaList[i].isSubscribed = true;
                    }

                    else if (userSnap.data().type == "user" || this.isSubscribed) {
                        this.postsMediaList[i].isSubscribed = true;
                    }


                    // else {
                    //     for (let i = 0; i < fanList.length; i++) {
                    //         if (fanList[i] == auth.currentUser.uid) {
                    //             this.postsMediaList[index].isSubscribed = true;
                    //             break;
                    //         }
                    //     }
                    // }

                    // for (let i = 0; i < likedList.length; i++) {
                    //     if (likedList[i] == auth.currentUser.uid) {
                    //         this.postsMediaList[index].isLiked = true;
                    //         break;
                    //     }
                    // }

                    // for (let i = 0; i < bookmarkList.length; i++) {
                    //     if (bookmarkList[i] == auth.currentUser.uid) {
                    //         this.postsMediaList[index].isBookmarked = true;
                    //         break;
                    //     }
                    // }

                    for (let e = 0; e < paidUsers.length; e++) {
                        if (paidUsers[e] == auth.currentUser.uid) {
                            this.postsMediaList[index].isPaid = true;
                            break;
                        }
                    }

                }



            }
        },

        async getPosts() {

            //start loading
            let res = [];

            const q = query(collection(db, "UserPosts"), where('userId', '==', sessionStorage.getItem("otherId")), orderBy('timeStampN'), limit(10), startAfter(this.lastDocSnapshot || 0));
            const querySnapshot = await getDocs(q);

            res = querySnapshot.docs.map(p => p.data());
            this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1];

            if (querySnapshot.docs.length > 0) {

                document.getElementById('emptyPost').style.display = 'none';

                querySnapshot.forEach(async (doc) => {

                    let urlList = [];
                    let imgCount = 0;
                    let vidCount = 0;

                    let a1 = Number(doc.data().timeStamp.seconds) * 1000;
                    let a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));

                    let result = {
                        isLoading: true,
                        id: doc.id,
                        idD: doc.data().idD,
                        userId: doc.data().userId,
                        fullName: this.displayName,
                        userName: this.userName,
                        profilePic: this.profilePic,
                        sexuality: this.sexuality,

                        isOwner: false,
                        isSubscribed: false,
                        tags: doc.data().tags,
                        caption: doc.data().caption,
                        category: doc.data().category,

                        timeStamp: doc.data().timeStamp,
                        dateFull: a2.slice(0, -36),
                        dateD: this.timeFormat(a1),


                        price: doc.data().price,
                        previewUrl: doc.data().previewUrl,
                        mediaList: doc.data().mediaList,

                        isLiked: false,
                        isBookmarked: false,

                        likeCount: this.kFormatter(doc.data().likeCount),
                        bookmarkCount: this.kFormatter(doc.data().bookmarkCount),
                        commentCount: this.kFormatter(doc.data().commentCount),

                        toggler: false,
                        urlList: urlList,
                        imgCount: imgCount,
                        vidCount: vidCount,
                        previewUrl2: [doc.data().previewUrl],

                        postType: doc.data().postType,
                        isPaid: false,
                        priceD: Number(doc.data().price).toLocaleString("us-US")


                    }

                    this.postsList.push(result);

                    let mIndex = this.postsList.length - 1;

                    this.getFullName(doc.id, doc.data().userId, doc.data().mediaList, doc.data().previewUrl, mIndex);

                })

                this.$refs.loadingModal.classList.remove("bg-active");
            }

            return res.length;

        },

        async getPostsMedia() {

            //start loading
            const auth = getAuth();
            let res = [];

            const q = query(collection(db, "UserPosts"), where('userId', '==', sessionStorage.getItem("otherId")), orderBy('timeStampN'), limit(10), startAfter(this.lastDocSnapshot2 || 0));
            const querySnapshot = await getDocs(q);

            res = querySnapshot.docs.map(p => p.data());
            this.lastDocSnapshot2 = querySnapshot.docs[querySnapshot.docs.length - 1];
            if (querySnapshot.docs.length > 0) {

                querySnapshot.forEach(async (doc) => {

                    let urlList = [];
                    let imgCount = 0;
                    let vidCount = 0;
                    let a1 = Number(doc.data().timeStamp.seconds) * 1000;
                    let a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));

                    let result = {
                        
                        mediaList: doc.data().mediaList,

                        isLiked: false,
                        isBookmarked: false,

                        likeCount: this.kFormatter(doc.data().likeCount),
                        bookmarkCount: this.kFormatter(doc.data().bookmarkCount),
                        commentCount: this.kFormatter(doc.data().commentCount),

                        toggler: false,
                        urlList: urlList,
                        imgCount: imgCount,
                        vidCount: vidCount,
                        previewUrl2: [doc.data().previewUrl],
                    }

                    if(doc.data().previewUrl != '' && doc.data().mediaList.length > 0){

                            for(let i = 0; i < doc.data().mediaList.length; i++){

                                let mType = doc.data().mediaList[i].type;

                                if (mType.startsWith('image')){

                                    this.postsMediaList.push({
                                        id: doc.id,
                                        type: "image",
                                        url: doc.data().mediaList[i].url,
                                        isOwner: true,
                                        subscribed: true,
                                        toggler: false,
                                        urlList: [doc.data().mediaList[i].url],

                                        postType: doc.data().postType,
                                        isPaid: false,
                                        price: doc.data().price,
                                        priceD: Number(doc.data().price).toLocaleString("us-US")
                                    })

                                }

                                else if (mType.startsWith('video')){

                                    this.postsMediaList.push({
                                        id: doc.id,
                                        type: "video",
                                        url: doc.data().mediaList[i].url,
                                        isOwner: true,
                                        subscribed: true,
                                        toggler: false,
                                        urlList: [doc.data().mediaList[i].url],

                                        postType: doc.data().postType,
                                        isPaid: false,
                                        price: doc.data().price,
                                        priceD: Number(doc.data().price).toLocaleString("us-US")
                                    })

                                }

                                
                                
                            }

                            this.getFullName2(doc.id, doc.data().userId);
                            document.getElementById('emptyMedia').style.display ='none';

                    }

                })

                this.$refs.loadingModal.classList.remove("bg-active");
            }

            return res.length;

        },

        async handleInfinite($state) {

            const wait = (n) => new Promise((resolve) => setTimeout(resolve, n));
            await wait(5000);

            const newPostCount = await this.getPosts();

            if (newPostCount > 0) {
                //more posts
                return $state.loaded();
            }

            //no more posts
            document.getElementById('emptyPost2').style.display = 'none';
            return $state.complete();

        },

        async handleInfinite2($state) {

            const newPostCount = await this.getPostsMedia();

            if (newPostCount > 0) {
                //more posts
                return $state.loaded();
            }

            //no more posts
            document.getElementById('emptyMedia2').style.display = 'none';
            return $state.complete();


        },

    }

}
</script>